<div *ngIf="showMainHeader && !bare">
  <!-- <div class="header-section" *ngIf="false"> -->
  <div class="header-section">
    <!-- Top bar (Figma Wireframe_v1 "TOP BAR"). Shop-front only — the account area drops it. -->
    <div class="top-bar" *ngIf="!isAccountPage">
      <div class="container top-bar-inner">
        <p class="top-bar-location">
          <span class="top-bar-dot" aria-hidden="true"></span>
          Brooklyn, NY
          <span class="top-bar-sep" aria-hidden="true">·</span>
          <span class="top-bar-accent">Same-day delivery within 25 mi</span>
        </p>
        <nav class="top-bar-links" aria-label="Utility">
          <a *ngIf="!adminWithoutCustomer" routerLink="/account/recent-order">Track your order</a>
          <a class="top-bar-samples" routerLink="/contact">Request samples</a>
          <ng-container *ngIf="!user">
            <a routerLink="/login">Log in</a>
            <a routerLink="/register">Register</a>
          </ng-container>
        </nav>
      </div>
    </div>
    <div class="container">
      <div class="header-center">
        <div class="header-nav-group d-flex align-items-center">
          <a routerLink="/" class="d-flex align-items-center" aria-label="S&F Supplies home">
            <img class="site-logo" src="/images/svg/home/hdr-logo.svg" alt="S&F Supplies Logo" />
          </a>
          <ul class="routerList">
            <li><a routerLink="/category" routerLinkActive="active" class="nav-link">Categories</a></li>
            <li><a routerLink="/brands" routerLinkActive="active" class="nav-link">Brands</a></li>
            <li><a routerLink="/about" routerLinkActive="active" class="nav-link">About</a></li>
            <li *ngIf="!adminWithoutCustomer"><app-quick-order-menu [signedIn]="!!user"></app-quick-order-menu></li>
          </ul>
        </div>
        <div class="header-actions-group d-flex align-items-center">
          <div class="d-flex align-items-center gap-2">
            <div (click)="showAccountPopup()" class="d-flex cursor align-items-center accountSection">
              <span class="account-btn" [class.open]="showLogin || showAccountPopupVisible"
                [attr.title]="user ? 'Hi, ' + user?.firstName : 'Sign In'">
                <img *ngIf="!user" class="account-icon" src="/images/svg/home/hdr-account.svg" alt="" width="18" height="18" aria-hidden="true" />
                <span *ngIf="user" class="account-initial">{{user?.firstName?.charAt(0) || 'A' | titlecase}}</span>
              </span>


              <div *ngIf="!user && showLogin" class="LoginPopup" (click)="$event.stopPropagation()">
                <!-- <a type="button" class="btn-close" (click)="showLogin = false"></a> -->
                <div class="d-flex align-items-center account-outer noHover">
                  <img src="/images/svg/m-user.svg" class="me-2 mb-0" alt="">
                  <h6 class="m-0 d-flex flex-column ">Welcome!
                    <span class="loginFont m-0 mt-1">Log In to view orders, quotes, and saved items</span>
                  </h6>
                </div>
                <a class="registerBtn mb-0" routerLink="/register" (click)="showLogin = false">Create
                  Account</a>
                <a class="loginBtn" routerLink="/login" (click)="showLogin = false">LOG IN</a>
              </div>

              <div *ngIf="user && showAccountPopupVisible" class="LoginPopup" (click)="$event.stopPropagation()">
                <!-- <a type="button" class="btn-close" (click)="showLogin = false"></a> -->
                <a class="d-flex account-outer" [routerLink]="adminWithoutCustomer ? '/account/security' : '/account'"
                  (click)="showAccountPopupVisible = false">
                  <div *ngIf="user" class="active-user me-2">{{user?.firstName?.charAt(0) || 'A' | titlecase}}</div>
                  <div class="w-100">
                    <h6 class="m-0">{{user?.firstName}} {{user?.lastName}}</h6>
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <span class="loginFont m-0 me-3">{{user?.email}}</span>
                      <div class="icon me-2" style="--icon: url('/images/svg/arrow-up.svg')"></div>
                    </div>
                  </div>
                </a>
                <!-- <button class="registerBtn mb-0" routerLink="/register" (click)="showLogin = false">Create
                  Account</button>
                <button class="loginBtn" routerLink="/login" (click)="showLogin = false">LOG IN</button> -->
                <div class="d-flex flex-column">
                  <a *ngIf="this.user && isAdmin && !loggedAsCustomer" routerLink="/admin"
                    (click)="showAccountPopupVisible = false">
                    <div class="icon me-2" style="--icon: url('/admin-dash.svg')"></div>
                    Admin Dashboard
                  </a>
                  <a *ngIf="!adminWithoutCustomer" routerLink="/account/recent-order"
                    (click)="showAccountPopupVisible = false">
                    <div class="icon me-2" style="--icon: url('/fast-delivery.svg')"></div>
                    My Orders
                  </a>

                  <a *ngIf="!adminWithoutCustomer" routerLink="/account/quotes"
                    (click)="showAccountPopupVisible = false">
                    <div class="icon me-2" style="--icon: url('/quotes.svg')"></div>
                    My Quotes
                  </a>

                  <a *ngIf="!adminWithoutCustomer" routerLink="/account/wishlist"
                    (click)="showAccountPopupVisible = false">
                    <div class="icon me-2" style="--icon: url('/images/svg/favt.svg')"></div>
                    Saved Items
                  </a>
                </div>
                <a *ngIf="adminWithoutCustomer" routerLink="/account/security"
                  (click)="showAccountPopupVisible = false">
                  <div class="icon me-2" style="--icon: url('/change-pass.svg')"></div>
                  Change Password
                </a>

                <a (click)="logout()" class="logout">
                  <div class="icon me-2" style="--icon: url('/logout.svg')"></div>
                  Logout
                </a>

              </div>
            </div>

            <a *ngIf="!adminWithoutCustomer" class="d-flex cursor align-items-center cart-link"
              routerLink="/shopping-cart" aria-label="Shopping cart">
              <img src="/images/svg/home/hdr-cart.svg" alt="" width="16" height="16" aria-hidden="true" />
              <span class="cart-label">Cart</span>
              <span class="cart-badge">{{ (cartList?.items?.length ? cartCount : 0) | number }}</span>
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="header-center">
        <div class="d-flex align-items-center justify-content-center" style="gap: 15px" *ngIf="!showSearchInput">
          <div class="mobile-menu-toggle" (click)="toggleMobileMenu()">
            <img src="iconamoon_menu-burger-horizontal-duotone.svg" />
          </div>
          <img routerLink="/" class="site-logo" src="sf-logo.png" alt="" />
        </div>
        <div class="search-bar">
          <ul class="queryListUl px-4 d-flex" *ngIf="ShowList">
            <div style="width: 55%;">
              <span class="title">Query Suggestions</span>
              <li (click)="setSearchVal(item.highlights[0].snippet)" class="coursor" style="height: 60px;"
                *ngFor="let item of queryList;let i = index" [class.active]="i === activeIndex"><span
                  [innerHTML]="getQueryName(item.highlights[0].snippet)"></span>
              
              </li>
            </div>
            <div style="width: 45%;">
              <span class="title">Products for {{searchValue}}</span>
              <li class="trending trending-product" *ngFor="let item of pQueryList; let i = index"
                (click)="goToProductDetail(item.document.urlSlug)">
                <span class="trend-no">
                  {{ i + 1 | number:'2.0' }}.
                </span>
                <img [src]="item.document.imageUrl || 'placeholder.svg'" alt="">
                <div class="t-name">{{item.document.name.slice(0,40)+'...'}}</div>
              </li>
            </div>

          </ul>
          <div class="input-group custom-dropdown" style="width: fit-content">
            <div class="dropdown">
              <button (click)="toggleMainDropdown()"
                class="category-button dropdown-toggle-button form-select category text-start w-100" id="categorySelect"
                type="button">
                {{ selectedCategoryDisplayName || "All Product" }}
              </button>
              <ul class="dropdown-menu p-0" [ngClass]="{ 'show': mainDropdownOpen }" *ngIf="mainDropdownOpen">
                <li>
                  <a class="dropdown-item" href="javascript:void(0)" (click)="onCategoryChange('')">
                    All Categories
                  </a>
                </li>

                <ng-container *ngFor="let category of MenuList">
                  <ng-template [ngTemplateOutlet]="categoryTemplate"
                    [ngTemplateOutletContext]="{ $implicit: category, level: 0 }">
                  </ng-template>
                </ng-container>
              </ul>

              <ng-template #categoryTemplate let-category let-level="level">
                <li>
                  <div class="dropdown-item d-flex justify-content-between align-items-center">
                    <span class="categoryItem"
                      [ngClass]="category.categoryName == selectedCategoryDisplayName ? 'activeCategory' : '' "
                      (click)="onCategoryChange(category.urlSlug)">
                      {{ category.categoryName}}
                    </span>

                    <button *ngIf="category.childCategories?.length" class="btn btn-sm dropdown-item first border-0"
                      [ngClass]="{ 'open': category.isSubMenuOpen, 'closed': !category.isSubMenuOpen }"
                      (click)="toggleCategory(category); $event.stopPropagation();">
                    </button>
                  </div>

                  <ul class="ps-0" *ngIf="category.isSubMenuOpen">
                    <ng-container *ngFor="let child of category.childCategories">
                      <ng-template [ngTemplateOutlet]="categoryTemplate"
                        [ngTemplateOutletContext]="{ $implicit: child, level: level + 1 }">
                      </ng-template>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>


            </div>
          </div>
          <input class="search-input pc" type="text" placeholder="Search Products" [(ngModel)]="searchValue"
            (keyup)="onSearchKeyUp($event)" (input)="onchangeInput()" (keydown.enter)="onSearchEnter()" />
          <div class="search-icon-svg pc">
            <img class="search-icon" src="search.svg" alt="" (click)="onClickSearch()" />
          </div>

        </div>

        <div class="account-info">
          <div class="m-inner-acc-info d-flex align-items-center justify-content-center" *ngIf="!showSearchInput">
            <div (click)="ClickOutside()" class="d-sm-block d-lg-none">
              <a routerLink="/shopping-cart" class="cart-section d-flex pe-2 px-0 pb-1 pb-lg-0">
                <span class="me-2 d-none d-lg-block">Cart</span>
                <img class="user-icon" src="/images/cart-icon-new.svg" alt="" />
                <span class="cart-section-count" *ngIf="cartList?.items && cartList?.items.length !== 0">{{
                  this.cartCount | number
                  }}</span>
              </a>
            </div>

            <div *ngIf="!user?.userName" class="LoginDiv">
              <a class="coursor" (click)="ClickOutside(); saveUri()">Login</a>
              <a (click)="ClickOutside()" routerLink="register">Register</a>
            </div>
            <div *ngIf="user?.userName" class="d-flex align-items-center user">
              <div class="d-none d-lg-block" *ngIf="isAdmin && !loggedAsCustomer">
                <a href="javascript:void(0)" routerLink="/admin">Admin Portal</a>
              </div>
              <div class="userdetail d-flex align-items-center pcUser">
                <a (click)="ClickOutside()">{{ user?.firstName }} {{ user?.lastName }}
                </a>
                <span class="user-circle">
                  <svg class="d-lg-block d-none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    viewBox="0 0 16 16" fill="none">
                    <path
                      d="M1.33301 13.0003C1.33301 12.1163 1.6842 11.2684 2.30932 10.6433C2.93444 10.0182 3.78229 9.66699 4.66634 9.66699H11.333C12.2171 9.66699 13.0649 10.0182 13.69 10.6433C14.3152 11.2684 14.6663 12.1163 14.6663 13.0003C14.6663 13.4424 14.4907 13.8663 14.1782 14.1788C13.8656 14.4914 13.4417 14.667 12.9997 14.667H2.99967C2.55765 14.667 2.13372 14.4914 1.82116 14.1788C1.5086 13.8663 1.33301 13.4424 1.33301 13.0003Z"
                      stroke="white" stroke-width="1.5" stroke-linejoin="round" />
                    <path
                      d="M8 6.3335C9.38071 6.3335 10.5 5.21421 10.5 3.8335C10.5 2.45278 9.38071 1.3335 8 1.3335C6.61929 1.3335 5.5 2.45278 5.5 3.8335C5.5 5.21421 6.61929 6.3335 8 6.3335Z"
                      stroke="white" stroke-width="1.5" />
                  </svg>
                  <div (click)="ClickOutside()" class="d-sm-block d-lg-none dropdown user-dropdown-wrapper mt-1"
                    [class.show]="dropdownOpen">
                    <button class="btn btn-transparent border-0 dropdown-toggle d-flex align-items-center ps-1 m-0 px-0"
                      type="button" aria-expanded="dropdownOpen">
                      <svg class="user-icon2" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                        viewBox="0 0 512 512" fill="white">
                        <path
                          d="M256 0C114.62 0 0 114.617 0 256s114.62 256 256 256 256-114.617 256-256S397.38 0 256 0zm0 96c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64zm0 352c-52.935 0-99.854-25.788-129.282-65.623 1.298-42.185 85.522-65.377 129.282-65.377 43.59 0 127.984 23.042 129.284 65.377C355.853 422.212 308.935 448 256 448z" />
                      </svg>
                    </button>
                    <div class="mobile-account-sidebar" *ngIf="mobileAccountMenuOpen">
                      <div class="sidebar-overlay"></div>
                      <div class="sidebar-content"
                        [ngClass]="{ 'open': mobileAccountMenuOpen, 'close': !mobileAccountMenuOpen }">
                        <div class="user-name">
                          {{ user?.firstName }} {{ user?.lastName }}
                          <p class="m-signOut" (click)="logout()"><img src="/images/svg/signout.svg" alt=""
                              (click)="logout()" />
                            Sign Out</p>
                        </div>
                        <ul>
                          <li>
                            <div class="box d-flex align-items-center" (click)="onClickWishlist() "
                              *ngIf="this.user?.customer">
                              <p class="mb-0"><img src="/images/svg/my-wishlist.svg" alt=""></p>
                              <span class="ms-2">My Wishlist</span>
                            </div>
                          </li>

                          <li (click)="onClickAccount()">
                            <div class="box d-flex align-items-center">
                              <p class="mb-0"><img src="/images/svg/my-account.svg" alt=""></p>
                              <span class="ms-2">My Account</span>
                            </div>
                          </li>

                          <li (click)="onClickOrder()">
                            <div class="box d-flex align-items-center" (click)="onClickOrder()"
                              *ngIf="this.user?.customer">
                              <p class="mb-0"><img src="/images/svg/my-orders.svg" alt=""></p>
                              <span class="ms-2">My Orders</span>
                            </div>
                          </li>

                          <li *ngIf="isAdmin && !loggedAsCustomer" (click)="onClickAdmin()">
                            <div class="box d-flex align-items-center" *ngIf="this.user?.customer">
                              <p class="mb-0"><img src="/images/svg/my-account.svg" alt=""></p>
                              <a class="ms-2" href="javascript:void(0)" routerLink="/admin">Admin Portal</a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </span>
                <div class="onUserHover">
                  <div class="user-info text-center pt-4">
                    <img src="/images/svg/user.svg" class="user-img mb-2" alt="User Image" />
                    <p class="role mb-0">{{ user?.firstName }} {{ user?.lastName }}</p>
                    <p class="signOut" (click)="logout()"><img src="/images/svg/signout.svg" alt=""
                        (click)="logout()" />
                      Sign Out</p>
                  </div>
                  <div class="footer-sec d-flex justify-content-evenly">
                    <div class="box d-flex flex-column" (click)="onClickAccount()">
                      <p class="mb-2"><img src="/images/svg/my-account.svg" alt=""></p>
                      <span>My Account</span>
                    </div>
                    <div class="box d-flex flex-column" (click)="onClickOrder()" *ngIf="this.user?.customer">
                      <p class="mb-2"><img src="/images/svg/my-orders.svg" alt=""></p>
                      <span>My Orders</span>
                    </div>
                    <div class="box d-flex flex-column" (click)="onClickWishlist()" *ngIf="this.user?.customer">
                      <p class="mb-2"><img src="/images/svg/my-wishlist.svg" alt=""></p>
                      <span>My Wishlist</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="userdetail d-flex align-items-center MobileUser" (click)="toggleMobileAccountMenu()">
                <a (click)="ClickOutside()">{{ user?.firstName }} {{ user?.lastName }}
                </a>
                <span class="user-circle">
                  <svg class="d-lg-block d-none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    viewBox="0 0 16 16" fill="none">
                    <path
                      d="M1.33301 13.0003C1.33301 12.1163 1.6842 11.2684 2.30932 10.6433C2.93444 10.0182 3.78229 9.66699 4.66634 9.66699H11.333C12.2171 9.66699 13.0649 10.0182 13.69 10.6433C14.3152 11.2684 14.6663 12.1163 14.6663 13.0003C14.6663 13.4424 14.4907 13.8663 14.1782 14.1788C13.8656 14.4914 13.4417 14.667 12.9997 14.667H2.99967C2.55765 14.667 2.13372 14.4914 1.82116 14.1788C1.5086 13.8663 1.33301 13.4424 1.33301 13.0003Z"
                      stroke="white" stroke-width="1.5" stroke-linejoin="round" />
                    <path
                      d="M8 6.3335C9.38071 6.3335 10.5 5.21421 10.5 3.8335C10.5 2.45278 9.38071 1.3335 8 1.3335C6.61929 1.3335 5.5 2.45278 5.5 3.8335C5.5 5.21421 6.61929 6.3335 8 6.3335Z"
                      stroke="white" stroke-width="1.5" />
                  </svg>
                  <div (click)="ClickOutside()" class="d-sm-block d-lg-none dropdown user-dropdown-wrapper mt-1"
                    [class.show]="dropdownOpen">
                    <button class="btn btn-transparent border-0 dropdown-toggle d-flex align-items-center ps-1 m-0 px-0"
                      type="button" aria-expanded="dropdownOpen">
                      <svg class="user-icon2" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                        viewBox="0 0 512 512" fill="white">
                        <path
                          d="M256 0C114.62 0 0 114.617 0 256s114.62 256 256 256 256-114.617 256-256S397.38 0 256 0zm0 96c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64zm0 352c-52.935 0-99.854-25.788-129.282-65.623 1.298-42.185 85.522-65.377 129.282-65.377 43.59 0 127.984 23.042 129.284 65.377C355.853 422.212 308.935 448 256 448z" />
                      </svg>
                    </button>
                    <div class="mobile-account-sidebar" *ngIf="mobileAccountMenuOpen">
                      <div class="sidebar-overlay"></div>
                      <div class="sidebar-content"
                        [ngClass]="{ 'open': mobileAccountMenuOpen, 'close': !mobileAccountMenuOpen }">
                        <div class="user-name">
                          {{ user?.firstName }} {{ user?.lastName }}
                          <p class="m-signOut" (click)="logout()"><img src="/images/svg/signout.svg" alt=""
                              (click)="logout()" />
                            Sign Out</p>
                        </div>
                        <ul>
                          <li>
                            <div class="box d-flex align-items-center" (click)="onClickWishlist() "
                              *ngIf="this.user?.customer">
                              <p class="mb-0"><img src="/images/svg/my-wishlist.svg" alt=""></p>
                              <span class="ms-2">My Wishlist</span>
                            </div>
                          </li>

                          <li (click)="onClickAccount()">
                            <div class="box d-flex align-items-center">
                              <p class="mb-0"><img src="/images/svg/my-account.svg" alt=""></p>
                              <span class="ms-2">My Account</span>
                            </div>
                          </li>

                          <li (click)="onClickOrder()">
                            <div class="box d-flex align-items-center" (click)="onClickOrder()"
                              *ngIf="this.user?.customer">
                              <p class="mb-0"><img src="/images/svg/my-orders.svg" alt=""></p>
                              <span class="ms-2">My Orders</span>
                            </div>
                          </li>

                          <li *ngIf="isAdmin && !loggedAsCustomer" (click)="onClickAdmin()">
                            <div class="box d-flex align-items-center" *ngIf="this.user?.customer">
                              <p class="mb-0"><img src="/images/svg/my-account.svg" alt=""></p>
                              <a class="ms-2" href="javascript:void(0)" routerLink="/admin">Admin Portal</a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </span>
                <div class="onUserHover">
                  <div class="user-info text-center pt-4">
                    <img src="/images/svg/user.svg" class="user-img mb-2" alt="User Image" />
                    <p class="role mb-0">{{ user?.firstName }} {{ user?.lastName }}</p>
                    <p class="signOut" (click)="logout()"><img src="/images/svg/signout.svg" alt=""
                        (click)="logout()" />
                      Sign Out</p>
                  </div>
                  <div class="footer-sec d-flex justify-content-evenly">
                    <div class="box d-flex flex-column" (click)="onClickAccount()">
                      <p class="mb-2"><img src="/images/svg/my-account.svg" alt=""></p>
                      <span>My Account</span>
                    </div>
                    <div class="box d-flex flex-column" (click)="onClickOrder()" *ngIf="this.user?.customer">
                      <p class="mb-2"><img src="/images/svg/my-orders.svg" alt=""></p>
                      <span>My Orders</span>
                    </div>
                    <div class="box d-flex flex-column" (click)="onClickWishlist()" *ngIf="this.user?.customer">
                      <p class="mb-2"><img src="/images/svg/my-wishlist.svg" alt=""></p>
                      <span>My Wishlist</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-lg-block d-none" *ngIf="user?.userName">
              <a routerLink="/shopping-cart" class="cart-section d-flex">
                <span class="me-2 d-none d-lg-block">Cart</span>
                <img class="user-icon" src="/images/cart-icon-new.svg" alt="" />
                <span class="cart-section-count" *ngIf="cartList?.items && cartList?.items.length !== 0">{{
                  this.cartCount | number
                  }}</span>
              </a>
            </div>
          </div>
        </div>
        
        <div class="menu-overlay d-lg-none" *ngIf="showMobileMenu">
          <div class="mobile-account-menu d-lg-none"
            [ngClass]="{'menu-open': showMobileMenu,'menu-closed': !showMobileMenu }" *ngIf="showMobileMenu"
            (clickOutside)="ClickOutside()">
            <div class="account-info-mobile">
              <div class="container container-inner">
                <ul class="ps-0 menuList">
                  <li class="home-list-btn" *ngIf="MenuList.length > 0" routerLink="/"
                    (click)="ClickOutside(); visible = false">
                    <strong>Home</strong>
                  </li>
                  <li (click)="onClickMenuList(category)" class="categoryName" *ngFor="let category of MenuList">
                    <div class="category-header" (click)="toggleCategory(category)">
                      <strong>
                        {{ category.categoryName }}
                      </strong>
                      <span *ngIf="category.childCategories?.length > 0" class="arrow">
                        <i class="fas" [ngClass]="
                          category.isSubMenuOpen
                            ? 'fa-chevron-up'
                            : 'fa-chevron-down'
                        "></i>
                      </span>
                    </div>
                    <ul class="sub-menu" *ngIf="category.isSubMenuOpen">
                      <li *ngFor="let sub of category.childCategories">
                        <div class="sub-cat-wrapper">
                          <a class="nav-link sub-cat" (click)="onClick(sub)">
                            {{ sub.categoryName }}
                            <span *ngIf="sub.childCategories?.length > 0" class="arrow">
                              <i class="fas" [ngClass]="
                                sub.isSubMenuOpen
                                  ? 'fa-chevron-up'
                                  : 'fa-chevron-down'
                              " (click)="
                                toggleSubCategory(sub); $event.stopPropagation()
                              ">
                              </i>
                            </span>
                          </a>
                          <ul class="child-list" *ngIf="sub.isSubMenuOpen">
                            <li class="p-0 pt-2" *ngFor="
                              let detail of sub.childCategories.slice(0, 3)
                            ">
                              <a href="javascript:void(0)" (click)="
                                CategoryClick(
                                  'category/' +
                                    category.urlSlug +
                                    '/' +
                                    sub.urlSlug +
                                    '/' +
                                    detail.urlSlug
                                )
                              " class="nav-link">{{ detail.categoryName }}</a>
                            </li>
                            <li class="p-0" *ngIf="sub.childCategories.length > 3" class="viewAll mt-2">
                              <a href="javascript:void(0)" (click)="
                                CategoryClick(
                                  'category/' +
                                    category.urlSlug +
                                    '/' +
                                    sub.urlSlug
                                )
                              ">
                                View All
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div> -->
    </div>

    <!-- Search row (Figma Wireframe_v1 "SEARCH ROW"): the catalogue search gets its own band. -->
    <div class="search-row">
      <div class="container search-row-inner">
        <p class="search-row-tagline">Over 20,000 products <span>in under 20 seconds</span></p>
        <div class="search-field">
          <div class="input">
            <img (click)="onClickSearch()" class="searchIcon cursor" src="/images/svg/home/hdr-search.svg" alt="" width="16" height="16">
            <input type="text" name="searchBtn" id="searchbar"
              placeholder="Search in plain English, like &quot;that orange banner tape you sent&quot;" autocomplete="off"
              [(ngModel)]="searchValue" (keyup)="onSearchKeyUp($event)" (input)="onchangeInput()" (focus)="onFocus()"
              (blur)="onBlur()" (keydown.enter)="onSearchEnter()">
            <a type="button" *ngIf="searchValue" (click)="handleClose()" class="btn-close"></a>
            <ul class="queryListUl px-4" [class.show]="ShowList">
              <li *ngFor="let item of queryList; let i = index" class="coursor" [class.active]="i === activeIndex"
                (click)="setSearchVal(item.highlights[0].snippet)"><span
                  [innerHTML]="getQueryName(item.highlights[0].snippet)"></span>
              </li>
              <li *ngIf="pQueryList?.length">
                <p class="title">Products Related To {{searchValue}}</p>
              </li>
              <li class="trending trending-product" *ngFor="let item of pQueryList; let i = index"
                [class.active]="i + (queryList?.length || 0) === activeIndex"
                (click)="goToProductDetail(item.document.urlSlug)">
                <img [src]="item.document.imageUrl || 'placeholder.svg'" alt="">
                <div class="t-name">{{item.document.name.slice(0,40) | titlecase}}</div>
              </li>
            </ul>
          </div>
          <button type="button" class="search-submit" (click)="onClickSearch()">Search</button>
        </div>
      </div>
    </div>
  </div>

  <div class="mobileHeader">
    <!-- Promo / announcement bar (mobile) -->
    <div class="mobile-promo-bar" *ngIf="!isAccountPage">
      <div class="mobile-promo-message">
        <span class="mobile-promo-text">
            <svg class="mobile-promo-tag-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z"
            stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
          <circle cx="7" cy="7" r="1.4" fill="currentColor" />
        </svg>
          Commercial Pricing Available</span>
      </div>
      <a routerLink="/register" class="mobile-promo-apply">Apply Now
        <svg class="mobile-promo-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </a>
    </div>
    <div [style.overflow]="!overflowXValue ? 'hidden' : 'visible'"
      class="container outerBox py-3 d-flex align-items-center justify-content-between">
      <a class="image cursor" routerLink="/" aria-label="S&F Supplies home">
        <img class="mobile-site-logo" src="/images/svg/sf-logo-emerson.svg" alt="S&F Supplies Logo">
      </a>
      <div [style.opacity]="searchEnabled ? '0' : '1'" (click)="toggleSearch()" class="search cursor">
        <img src="./mobileSearch.svg" alt="">
      </div>
      <div [ngClass]="{'visible':searchEnabled}" class="container searcHeader d-flex align-items-center">
        <div class="input w-100">
          <img (click)="onClickSearch()" class="searchIcon cursor" src="./mobileSearch.svg" alt="">
          <input type="text" name="searchBtn" id="searchbar1" placeholder="Search Products" autocomplete="off"
            [(ngModel)]="searchValue" (keyup)="onSearchKeyUp($event)" (input)="onchangeInput()" (focus)="onFocus()"
            (blur)="onBlur()" (keydown.enter)="onSearchEnter()">
          <a type="button" *ngIf="searchValue" (click)="handleClose()" class="btn-close"></a>
          <ul class="queryListUl px-4" [class.show]="ShowList">
            <li *ngFor="let item of queryList; let i = index" class="coursor" [class.active]="i === activeIndex"
              (click)="setSearchVal(item.highlights[0].snippet)"><span
                [innerHTML]="getQueryName(item.highlights[0].snippet)"></span>
              <!-- <img class="ms-2" src="./query-logo.svg"alt=""> -->
            </li>
            <li *ngIf="pQueryList?.length">
              <p class="title">Products Related To {{searchValue}}</p>
            </li>
            <li class="trending trending-product" *ngFor="let item of pQueryList; let i = index"
              [class.active]="i + (queryList?.length || 0) === activeIndex"
              (click)="goToProductDetail(item.document.urlSlug)">
              <img [src]="item.document.imageUrl || 'placeholder.svg'" alt="">
              <div class="t-name">{{item.document.name.slice(0,40) | titlecase}}</div>
            </li>
          </ul>
        </div>
        <button class="ms-2 close" (click)="toggleSearch()">Close</button>
      </div>
    </div>

  </div>
  <div class="header-bar pt-2" [class.scrolled]="isScrolled"
    *ngIf="loggedAsCustomer && this.user && this.user.userName">
    <div class="header-left container d-flex">
      <a class="cursor" href="javascript:void(0)" (click)="backToAdmin()">← Back to Admin Portal</a>
      <div class="w-100 d-flex justify-content-center pb-1">
        <span class="header-right userHeaderPc">
          You are currently logged in as
          <span class="logged-user">{{ user?.firstName }} {{ user?.lastName
            }}<span class="loged-user-company ">({{ user?.customer.customerName }})</span>
          </span>
        </span>

        <span class="header-right userHeaderMob"><span class="p-1"> Logged in as</span>
          <span class="logged-user">{{ user?.firstName }} {{ user?.lastName}}<span class="loged-user-company">({{
              user?.customer.customerName }})</span>
          </span>
        </span>

      </div>
    </div>
  </div>
</div>


<div class="mobile-bottom-nav" *ngIf="!bare">
  <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    <img class="normal" src="/images/svg/m-home.svg" alt="">
    <img class="active-img" src="/images/svg/blue-m-home.svg" alt="">

    <!-- <div class="icon" style="--icon: url('/images/svg/m-home.svg')"></div> -->
    <span>Home</span>
  </a>

  <a routerLink="/category" routerLinkActive="active">
    <img class="normal" src="/images/svg/m-category.svg" alt="">
    <img class="active-img" src="/images/svg/blue-m-category.svg" alt="">
    <!-- <div class="icon" style="--icon: url('/images/svg/m-category.svg')"></div> -->
    <span>Categories</span>
  </a>

  <a class="cartBox" routerLink="/shopping-cart" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    <img class="normal" src="/images/svg/m-cart.svg" alt="">
    <img class="active-img" src="/images/svg/blue-m-cart.svg" alt="">
    <!-- <div class="icon" style="--icon: url('/images/svg/m-category.svg')"></div> -->
    <span>Cart</span>
    <div class="cart-section-count" *ngIf="cartList?.items && cartList?.items.length !== 0">
                <span>
                  {{ cartCount | number }}
                </span>
              </div>
  </a>

  <a [routerLink]="user ? '/account':'/login'" routerLinkActive="active">

    <img *ngIf="!user" class="normal" src="/images/svg/m-user.svg" alt="">
    <img *ngIf="!user" class="active-img" src="/images/svg/blue-m-user.svg" alt="">
    <div *ngIf="user" class="active-user">{{user?.firstName?.charAt(0) || 'A' | titlecase}}</div>
    <span> {{ user ? 'Hi, ' + user.firstName : 'Login' }}</span>
  </a>
</div>

<!-- multiple variants popup -->
<div class="custom-drawer-overlay" *ngIf="multipleVarientsPopupOpen" (click)="closeMultipleVarientsPopup()">
</div>

@if(addNewProduct){
<div class="custom-drawer multipleVarients addNewProduct" [class.open]="multipleVarientsPopupOpen" [class.gen-centered]="generatorMode" tabindex="-1">
  <div class="h-100 d-flex flex-column" [class.is-configuring]="addNewConfig">
    <div class="drawer-header d-flex justify-content-end align-items-center px-3">
          <a href="javascript:void(0)" (click)="closeMultipleVarientsPopup()">
           <img src="/images/svg/cross.svg" alt="Close" />
          </a>
    </div>
    <div class="max-header text-center" [class.addConfig]="addNewConfig">
      <h4 class="m-0">
        {{ (splitItemsIndividually && isConfiguringSplit) ? 'Configure Services for Selected Items' : 'S&F Services' }}
      </h4>
        <div class="service-subtitle">
        Organize your units and assign services
      </div>
      <p class="service-affect-note m-0">
        <img src="/images/svg/info.svg" alt="" class="service-affect-icon">
        Services may affect final quantity and pricing.
      </p>
    </div>
    @if (!addNewConfig) {

    <div class="drawer-body px-0">
    

      <!-- Sticky header: flow selector + unit stats stay pinned while cards scroll. -->
      <div class="units-sticky-header">
      <div class="flow-selection-row" *ngIf="flattenedSplitItems.length > 1 && !generatorMode">
        <button class="flow-btn" [class.active]="serviceFlow === 'together'" (click)="setServiceFlow('together')">
          ALL UNITS TOGETHER
        </button>
        <button *ngIf="flattenedSplitItems.length > 2" class="flow-btn" [class.active]="serviceFlow === 'groups'" (click)="setServiceFlow('groups')">
          SPLIT INTO GROUPS
        </button>
        <div class="tooltip-container" *ngIf="flattenedSplitItems.length > 1">
          <button class="flow-btn"
            [ngClass]="{'active': serviceFlow === 'separately', 'disabled': flattenedSplitItems.length > 10}"
            [disabled]="flattenedSplitItems.length > 10" (click)="setServiceFlow('separately')">
            EACH UNIT SEPARATELY
          </button>
          <div class="tooltip-text" *ngIf="flattenedSplitItems.length > 10">
            For large quantities, use ‘Split into Groups’ to organize units.
          </div>
        </div>
      </div>

      <div class="unit-stats-row">
        <div class="stat-item">Total: {{flattenedSplitItems?.length}} units</div>
        <div class="stat-item" *ngIf="serviceFlow == 'groups' && unassignedUnitsCount >= 0">Unassigned: {{unassignedUnitsCount}} units</div>
        <div class="stat-item" *ngIf="serviceFlow == 'groups' && unassignedUnitsCount < 0" style="color: #dc3545; font-weight: 600;">Exceeds total by {{-unassignedUnitsCount}} units</div>
      </div>
      </div><!-- /units-sticky-header -->

      <!-- Selection Mode: List individual units with checkboxes -->
      <div class=" split-selection-list"
        *ngIf="splitItemsIndividually && !isConfiguringSplit && serviceFlow !== 'separately'">
        <div class="item-service-box unit-card mb-3 p-3 d-flex align-items-center"
          *ngFor="let unit of flattenedSplitItems; trackBy: trackByUniqueIndex"
          [class.selected]="isUnitSelected(unit.uniqueIndex)" (click)="toggleUnitSelection(unit.uniqueIndex)">
          <div class="selection-check me-3">
            <input type="checkbox" class="form-check-input" [checked]="isUnitSelected(unit.uniqueIndex)"
              (click)="$event.stopPropagation(); toggleUnitSelection(unit.uniqueIndex)">
          </div>
          <div class="flex-grow-1">
            <h5 class="m-0 item-label">{{unit.displayLabel}}</h5>
          </div>
          <div class="item-attrs" *ngIf="unit?.product?.attributeSelector || unit?.attributeSelector">
            <ng-container *ngFor="let attr of (unit?.product?.attributeSelector || unit?.attributeSelector) | keyvalue">
              <span *ngFor="let val of $any(attr.value)">
                <span *ngIf="isAttributeActive(val, unit?.product || unit)" class="attribute-item">
                  {{val.attributeValue}}
                  <span class="color-dot" *ngIf="$any(attr).key?.toLowerCase()?.includes('color')"
                    [style.background-color]="val.attributeValue"></span>
                  <span class="square-swatch"
                    *ngIf="$any(attr).key?.toLowerCase()?.includes('finish') || $any(attr).key?.toLowerCase()?.includes('material')"></span>
                </span>
              </span>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Standard View / Configuration Step: Show Available Services -->
      <ng-container *ngIf="!splitItemsIndividually || isConfiguringSplit || serviceFlow === 'separately'">

        <!-- Together or Groups or Separately Flow -->
        <ng-container *ngIf="serviceFlow === 'together' || serviceFlow === 'groups' || serviceFlow === 'separately'">
          <div class="item-service-box mb-4 mt-3"
            *ngFor="let group of serviceGroups; let i = index; trackBy: trackByGroup">
            <div class="item-header d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column">
                <h5 class="m-0 item-label">{{group.label || ('GROUP ' + group.id)}}</h5>
                <!-- <span class="text-muted small mt-1"
                  style="text-transform: none; font-weight: 400; font-size: 14px;">{{group.configs?.length || 0}}
                  Services</span> -->
              </div>

              <!-- Attribute Display for Separately Flow -->
              <div class="d-flex align-items-center gap-2" *ngIf="serviceFlow === 'separately'">
                <div class="unit-attrs d-flex align-items-center gap-2">
                  <span class="small text-muted" *ngFor="let attr of group.attributes">
                     <ng-container *ngIf="attr.key?.toLowerCase() !== 'color group'">
                      {{ attr.value }}
                    </ng-container>
                    <!-- {{attr.value}} -->
                    <!-- <span class="color-dot" *ngIf="attr.key?.toLowerCase()?.includes('color')"
                      [style.background-color]="attr.value"></span> -->
                  </span>
                </div>
              </div>
              @if(serviceFlow === 'groups'){
              <div class="d-flex align-items-center gap-2">
                @if(group.isIndividual){
                <span class="text-muted small text-no-transform">1 unit</span>
                }@else {
                <div class="d-flex flex-column align-items-start position-relative">
                  <input type="number" class="form-control text-center p-1 group-qty-input"
                    [class.error-input]="group.qty > getGroupMaxQty(i)" [(ngModel)]="group.qty"
                    (ngModelChange)="onGroupQtyChange(i)" min="0" [max]="getGroupMaxQty(i)">
                  <p class="error-message" *ngIf="group.qty > getGroupMaxQty(i)">Exceeds available units.</p>
                </div>
                <span class="text-muted small text-no-transform">of {{getGroupMaxQty(i)}}</span>
                }
              </div>
              }@else if(serviceFlow === 'together'){
              <span class="text-muted small text-no-transform">{{group.qty}} units</span>
              }
            </div>

            <!-- <div class="px-4 pb-3" *ngIf="group.configs?.length > 0">
              <span class="text-muted small fw-bold">{{group.configs.length}} Service{{group.configs.length > 1 ? 's' :
                ''}}</span>
            </div> -->

            <div class="available-services-label px-4 pt-3">
              <h6 class="m-0">Which services would you like to apply?</h6>
            </div>
            <p class="px-4 pt-1 mb-0 text-muted small text-no-transform"
              *ngIf="serviceFlow === 'groups' && isGroupServiceLocked(group)">
              Finish configuring the active group before selecting services for another group.
            </p>

            <div class="variant-cards-list">

              <!-- Groups flow -->
              <ng-container *ngIf="serviceFlow === 'groups'">
                <ng-container *ngFor="let service of getFilteredServicesForConfig(group.unitRef || selectedProductForNewConfig); trackBy: trackByServiceName">

                  <!-- Already configured: show as "Added" card inline -->
                  <ng-container *ngFor="let entry of getConfigsWithIndexForService(group, service.name)">
                    <div class="configured-inline-card mb-3 mx-3"
                      [class.temp-highlight]="isJustSaved(entry.config.configId)">
                      <div class="d-flex align-items-center gap-2 gap-lg-3 flex-grow-1">
                        <img [src]="entry.config.img" alt="" class="service-inline-icon">
                        <div>
                          <span class="service-inline-name">{{entry.config.name}}
                            <!-- Bending: show selected shape -->
                            <span *ngIf="entry.config.name === 'Bending' && entry.config.bendPreset">
                              &bull; {{entry.config.bendPreset}} shape
                            </span>
                            <!-- Cutting / other: show cut count -->
                            <span  *ngIf="entry.config.name !== 'Bending' && entry.config.measurements?.length">
                              &bull; {{entry.config.measurements.length}} {{entry.config.name === 'Slitting' ? 'Slit' : 'cut'}}{{entry.config.measurements.length > 1 ? 's' : ''}}
                            </span>
                          </span>
                          <!-- Bending subtitle: bend count + outside material -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name === 'Bending'">
                            {{(entry.config.totalBends ?? entry.config.bendRows?.length) || 0}} Bend{{((entry.config.totalBends ?? entry.config.bendRows?.length) || 0) !== 1 ? 's' : ''}}<span *ngIf="selectedProductForNewConfig?.outsideMaterial"> &bull; {{selectedProductForNewConfig.outsideMaterial}} Outside</span>
                          </span>
                          <!-- Punching subtitle: no geometry, just a fixed note -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name === 'Punching'">Standard edge punching applied.</span>
                          <!-- Cutting / Slitting subtitle: pieces generated -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name !== 'Bending' && entry.config.name !== 'Punching'">{{entry.config.piecesQty}} piece{{entry.config.piecesQty > 1 ? 's' : ''}} generated</span>
                        </div>
                         <span class="added-badge" *ngIf="isJustSaved(entry.config.configId)">
                          <img src="/images/svg/blue-tick.svg" alt=""> Added
                        </span>
                      </div>
                      <div class="d-flex align-items-center gap-3">
                        <a href="javascript:void(0)" class="inline-config-link"
                          *ngIf="entry.config.name !== 'Punching'"
                          (click)="editGroupConfig(group, entry.idx)">
                          <img src="/images/svg/edit.svg" alt="edit" class="inline-config-icon"> Edit
                        </a>
                        <a href="javascript:void(0)" class="inline-config-link remove"
                          (click)="removeGroupConfig(group, entry.idx)">
                          <img src="/images/svg/delete.svg" alt="remove" class="inline-config-icon"> Remove
                        </a>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Not yet configured: show as selectable checkbox card -->
                  <div class="group-service-row"
                    *ngIf="!hasConfigsForService(group, service.name)"
                    [style.opacity]="(group.qty > 0 && !isGroupServiceLocked(group)) ? '1' : '0.5'"
                    [style.pointer-events]="(group.qty > 0 && !isGroupServiceLocked(group)) ? 'auto' : 'none'"
                    (click)="(group.qty > 0 && !isGroupServiceLocked(group)) && toggleGroupService(group, service)">
                    <label class="custom-checkbox d-flex" (click)="$event.stopPropagation()">
                      <div class="outer-checkBox">
                        <input type="checkbox" class="group-service-checkbox"
                          [checked]="isGroupServiceSelected(group.id, service.name)"
                          (change)="toggleGroupService(group, service)">
                        <div class="checkmark">
                          <img src="/images/svg/check-tick.svg" alt="checked">
                        </div>
                      </div>
                    </label>
                    <div class="variant-card flex-grow-1 m-0"
                      [class.variant-card-selected]="isGroupServiceSelected(group.id, service.name)">
                      <div class="d-flex align-items-center flex-grow-1">
                        <div class="service-icon-box">
                          <img [src]="service.img" alt="">
                        </div>
                        <div class="service-info-main">
                          <h5 class="m-0">{{service.name}}</h5>
                          <span class="attr-text">{{service.msg}}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center m-version-price">
                        <div class="price-section">
                          <div class="price-main">Starting at {{service.minimumServiceFee | currency: 'USD' : 'symbol' : '1.2-2'}} <span> (min {{service.includedQtyInMinimumFee}})</span> </div>
                          <div class="price-sub">+{{service.eachAdditionalPrice | currency: 'USD'}} per extra</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>
              </ng-container>

              <!-- Together flow -->
              <ng-container *ngIf="serviceFlow === 'together'">
                <ng-container *ngFor="let service of getFilteredServicesForConfig(group.unitRef || selectedProductForNewConfig); trackBy: trackByServiceName">

                  <!-- Already configured: show as "Added" card inline -->
                  <ng-container *ngFor="let entry of getConfigsWithIndexForService(group, service.name)">
                    <div class="configured-inline-card mb-3 mx-3"
                      [class.temp-highlight]="isJustSaved(entry.config.configId)">
                      <div class="d-flex align-items-center gap-2 gap-lg-3 flex-grow-1">
                        <img [src]="entry.config.img" alt="" class="service-inline-icon">
                        <div>
                          <span class="service-inline-name">{{entry.config.name}}
                            <!-- Bending: show selected shape -->
                            <span *ngIf="entry.config.name === 'Bending' && entry.config.bendPreset">
                              &bull; {{entry.config.bendPreset}} shape
                            </span>
                            <!-- Cutting / other: show cut count -->
                            <span *ngIf="entry.config.name !== 'Bending' && entry.config.measurements?.length">
                              &bull; {{entry.config.measurements.length}} {{entry.config.name === 'Slitting' ? 'Slit' : 'cut'}}{{entry.config.measurements.length > 1 ? 's' : ''}}
                            </span>
                          </span>
                          <!-- Bending subtitle: bend count + outside material -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name === 'Bending'">
                            {{(entry.config.totalBends ?? entry.config.bendRows?.length) || 0}} Bend{{((entry.config.totalBends ?? entry.config.bendRows?.length) || 0) !== 1 ? 's' : ''}}<span *ngIf="selectedProductForNewConfig?.outsideMaterial"> &bull; {{selectedProductForNewConfig.outsideMaterial}} Outside</span>
                          </span>
                          <!-- Punching subtitle: no geometry, just a fixed note -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name === 'Punching'">Standard edge punching applied.</span>
                          <!-- Cutting / Slitting subtitle: pieces generated -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name !== 'Bending' && entry.config.name !== 'Punching'">{{entry.config.piecesQty}} piece{{entry.config.piecesQty > 1 ? 's' : ''}} generated</span>
                        </div>
                          <span class="added-badge" *ngIf="isJustSaved(entry.config.configId)">
                          <img src="/images/svg/blue-tick.svg" alt="added"> Added
                        </span>
                      </div>
                      <div class="d-flex align-items-center gap-3">
                        <a href="javascript:void(0)" class="inline-config-link"
                          *ngIf="entry.config.name !== 'Punching'"
                          (click)="editGroupConfig(group, entry.idx)">
                          <img src="/images/svg/edit.svg" alt="edit" class="inline-config-icon"> Edit
                        </a>
                        <a href="javascript:void(0)" class="inline-config-link remove"
                          (click)="removeGroupConfig(group, entry.idx)">
                          <img src="/images/svg/delete.svg" alt="remove" class="inline-config-icon"> Remove
                        </a>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Not yet configured: show as selectable checkbox card -->
                  <div class="group-service-row"
                    *ngIf="!hasConfigsForService(group, service.name)"
                    [style.opacity]="(group.qty > 0 && !isGroupServiceLocked(group)) ? '1' : '0.5'"
                    [style.pointer-events]="(group.qty > 0 && !isGroupServiceLocked(group)) ? 'auto' : 'none'"
                    (click)="(group.qty > 0 && !isGroupServiceLocked(group)) && toggleGroupService(group, service)">
                    <label class="custom-checkbox d-flex" (click)="$event.stopPropagation()">
                      <div class="outer-checkBox">
                        <input type="checkbox" class="group-service-checkbox"
                          [checked]="isGroupServiceSelected(group.id, service.name)"
                          (change)="toggleGroupService(group, service)">
                        <div class="checkmark">
                          <img src="/images/svg/check-tick.svg" alt="checked">
                        </div>
                      </div>
                    </label>
                    <div class="variant-card flex-grow-1 m-0"
                      [class.variant-card-selected]="isGroupServiceSelected(group.id, service.name)">
                      <div class="d-flex align-items-center flex-grow-1">
                        <div class="service-icon-box">
                          <img [src]="service.img" alt="">
                        </div>
                        <div class="service-info-main">
                          <h5 class="m-0">{{service.name}}</h5>
                          <span class="attr-text">{{service.msg}}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center m-version-price">
                        <div class="price-section">
                          <div class="price-main">Starting at {{service.minimumServiceFee | currency: 'USD' : 'symbol' : '1.2-2'}} <span> (min {{service.includedQtyInMinimumFee}}) </span> </div>
                          <div class="price-sub">+{{service.eachAdditionalPrice | currency: 'USD'}} per extra</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>
              </ng-container>

              <!-- Separately flow: tick a service, then press "Configure Service" -->
              <ng-container *ngIf="serviceFlow === 'separately'">
                <ng-container *ngFor="let service of getFilteredServicesForConfig(group.unitRef || selectedProductForNewConfig); trackBy: trackByServiceName">

                  <!-- Already configured: show as "Added" card inline -->
                  <ng-container *ngFor="let entry of getConfigsWithIndexForService(group, service.name)">
                    <div class="configured-inline-card mb-3 mx-3"
                      [class.temp-highlight]="isJustSaved(entry.config.configId)">
                      <div class="d-flex align-items-center gap-2 gap-lg-3 flex-grow-1">
                        <img [src]="entry.config.img" alt="" class="service-inline-icon">
                        <div>
                          <span class="service-inline-name">{{entry.config.name}}
                            <!-- Bending: show selected shape -->
                            <span *ngIf="entry.config.name === 'Bending' && entry.config.bendPreset">
                              &bull; {{entry.config.bendPreset}} shape
                            </span>
                            <!-- Cutting / other: show cut count -->
                            <span *ngIf="entry.config.name !== 'Bending' && entry.config.measurements?.length">
                              &bull; {{entry.config.measurements.length}} {{entry.config.name === 'Slitting' ? 'Slit' : 'cut'}}{{entry.config.measurements.length > 1 ? 's' : ''}}
                            </span>
                          </span>
                          <!-- Bending subtitle: bend count + outside material -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name === 'Bending'">
                            {{(entry.config.totalBends ?? entry.config.bendRows?.length) || 0}} Bend{{((entry.config.totalBends ?? entry.config.bendRows?.length) || 0) !== 1 ? 's' : ''}}<span *ngIf="selectedProductForNewConfig?.outsideMaterial"> &bull; {{selectedProductForNewConfig.outsideMaterial}} Outside</span>
                          </span>
                          <!-- Punching subtitle: no geometry, just a fixed note -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name === 'Punching'">Standard edge punching applied.</span>
                          <!-- Cutting / Slitting subtitle: pieces generated -->
                          <span class="d-block text-muted small" *ngIf="entry.config.name !== 'Bending' && entry.config.name !== 'Punching'">{{entry.config.piecesQty}} piece{{entry.config.piecesQty > 1 ? 's' : ''}} generated</span>
                        </div>
                        <span class="added-badge" *ngIf="isJustSaved(entry.config.configId)">
                          <img src="/images/svg/blue-tick.svg" alt=""> Added
                        </span>
                      </div>
                      <div class="d-flex align-items-center gap-3">
                        <a href="javascript:void(0)" class="inline-config-link"
                          *ngIf="entry.config.name !== 'Punching'"
                          (click)="editGroupConfig(group, entry.idx)">
                          <img src="/images/svg/edit.svg" alt="edit" class="inline-config-icon"> Edit
                        </a>
                        <a href="javascript:void(0)" class="inline-config-link remove"
                          (click)="removeGroupConfig(group, entry.idx)">
                          <img src="/images/svg/delete.svg" alt="remove" class="inline-config-icon"> Remove
                        </a>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Not yet configured: tick to select (one or both), then "Configure Service" -->
                  <div class="group-service-row"
                    *ngIf="!hasConfigsForService(group, service.name)"
                    [class.cursor-pointer]="group.qty > 0"
                    [style.opacity]="group.qty > 0 ? '1' : '0.5'"
                    [style.pointer-events]="group.qty > 0 ? 'auto' : 'none'"
                    (click)="group.qty > 0 && toggleGroupService(group, service)">
                    <label class="custom-checkbox d-flex" (click)="$event.stopPropagation()">
                      <div class="outer-checkBox">
                        <input type="checkbox" class="group-service-checkbox"
                          [checked]="isGroupServiceSelected(group.id, service.name)"
                          (change)="toggleGroupService(group, service)">
                        <div class="checkmark">
                          <img src="/images/svg/check-tick.svg" alt="checked">
                        </div>
                      </div>
                    </label>
                    <div class="variant-card flex-grow-1 m-0"
                      [class.variant-card-selected]="isGroupServiceSelected(group.id, service.name)">
                      <div class="d-flex align-items-center flex-grow-1">
                        <div class="service-icon-box">
                          <img [src]="service.img" alt="">
                        </div>
                        <div class="service-info-main">
                          <h5 class="m-0">{{service.name}}</h5>
                          <span class="attr-text">{{service.msg}}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center m-version-price">
                        <div class="price-section">
                          <div class="price-main">Starting at {{service.minimumServiceFee | currency: 'USD' : 'symbol' :
                            '1.2-2'}} <span> (min {{service.includedQtyInMinimumFee}}) </span> </div>
                          <div class="price-sub">+{{service.eachAdditionalPrice | currency: 'USD'}} per extra</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>
              </ng-container>

            </div>

            <!-- Bend / cut relationship hint -->
            <p class="bend-context-note mx-4 mb-3" *ngIf="groupBendNote(group) as note">
              <img src="/images/svg/info.svg" alt="" class="bend-context-icon">
              <span>{{ note }}</span>
            </p>

            <!-- Upload File Section -->
            <div class="upload-section px-3 px-lg-4 mb-4 pt-2">
              <label class="form-label mb-1">Upload File (Optional)</label>
              <p class="mb-3 para">Add a diagram or instructions to insure accurate result.</p>

              <div *ngIf="!group.uploadedFile" class="upload-dropzone border-dashed rounded"
                (drop)="onFileDropped($event)" (dragover)="$event.preventDefault()">
                <div class="d-flex align-items-center gap-3">
                  <img src="./pdf-icon.svg" alt="" class="upload-icon">
                  <div class="d-flex flex-column align-items-start">
                    <p class="mb-0 upload-text">
                      Drop your file here, or
                      <label class="browse-link mb-0">
                        Browse Files
                        <input type="file" class="d-none" (change)="onFileSelected($event, group)">
                      </label>
                    </p>
                    <p class="text-muted mb-0 supported-text">Supported: PDF, JPG, PNG (max 5MB)</p>
                  </div>
                </div>
              </div>

              <div *ngIf="group.uploadedFile"
                class="file-upload-preview d-flex align-items-center justify-content-between p-3 border rounded">
                <div class="d-flex align-items-center gap-2">
                  <div class="file-icon-box">
                    <img src="/images/svg/pdf-1.svg" alt="pdf">
                  </div>
                  <div class="d-flex flex-column">
                    <span class="file-name">{{group.uploadedFile.name}}</span>
                    <span class="text-muted upload-status">Upload Successful</span>
                  </div>
                </div>
                <a href="javascript:void(0)" class="inline-config-link remove" (click)="onFileRemove(group)">
                  <img src="/images/svg/delete.svg" alt="remove" class="inline-config-icon"> Remove
                </a>
              </div>
            </div>
          </div>

          <!-- Groups: Add Individual Unit / Add Another Group -->
          <div class="d-flex gap-3 w-100 mb-4 px-lg-2 another-group-buttons" *ngIf="serviceFlow === 'groups'">
            <button class="btn btn-light w-100 fw-bold py-lg-3"
              [style.background]="unassignedUnitsCount === 0 ? '#f0f0f0' : '#EAF6FB'"
              [style.color]="unassignedUnitsCount === 0 ? '#aaa' : '#57A9D0'"
              style="border: none; border-radius: 8px;"
              [disabled]="unassignedUnitsCount === 0"
              (click)="addIndividualUnit()">
              ADD INDIVIDUAL UNIT
            </button>
            <button class="btn w-100 fw-bold py-lg-3"
              style="border: 2px solid #57A9D0; color: #57A9D0; border-radius: 8px; outline: none; box-shadow: none;"
              [disabled]="unassignedUnitsCount === 0"
              (click)="addServiceGroup()">
              + ADD ANOTHER GROUP
            </button>
          </div>
        </ng-container>

        <!-- Separately Flow Card (Configuring) -->
        <ng-container *ngIf="serviceFlow === 'separately' && isConfiguringSplit">
          <div class="item-service-box mb-4 mt-3"
            *ngFor="let item of (selectedVariantProducts.length > 0 ? selectedVariantProducts : [selectedProductForNewConfig]); let i = index">
            <!-- Existing separately flow logic if needed, but usually it uses the same card style -->
            <div class="item-header d-flex justify-content-between align-items-center">
              <h5 class="m-0 item-label">SELECTED ITEMS</h5>
              <div class="unit-count text-muted small fw-bold">
                {{selectedSplitIndices.size}} units
              </div>
            </div>

            <div class="available-services-label">
              <h6 class="m-0">Available Services</h6>
            </div>

            <div class="variant-cards-list">
              <div class="group-service-row"
                *ngFor="let service of getFilteredServicesForConfig(item?.product || item); trackBy: trackByServiceName"
                (click)="onSelectItemAndConfigure(item, service)">
                <label class="custom-checkbox d-flex" (click)="$event.stopPropagation()">
                  <div class="outer-checkBox">
                    <input type="checkbox" class="group-service-checkbox" [checked]="false" readonly>
                    <div class="checkmark">
                      <img src="/images/svg/check-tick.svg" alt="checked">
                    </div>
                  </div>
                </label>
                <div class="variant-card flex-grow-1 m-0">
                  <div class="d-flex align-items-center flex-grow-1">
                    <div class="service-icon-box">
                      <img [src]="service.img" alt="">
                    </div>
                    <div class="service-info-main">
                      <h5 class="m-0">{{service.name}}</h5>
                      <span class="attr-text">{{service.msg}}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center m-version-price">
                    <div class="price-section">
                      <div class="price-main">Starting at {{service.minimumServiceFee | currency: 'USD' : 'symbol' :
                        '1.2-2'}} <span> (min {{service.includedQtyInMinimumFee}}) </span> </div>
                      <div class="price-sub">+{{service.eachAdditionalPrice | currency: 'USD'}} per extra</div>
                    </div>
                    <img src="/images/svg/dropdown.svg" alt="" class="chevron-blue">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </ng-container>
    </div>

    <!-- Together / Groups Footer: checkbox-select then configure -->
    <div class="drawer-footer mt-2 px-lg-4 pb-lg-4" *ngIf="serviceFlow === 'together' || serviceFlow === 'groups'">
      <a href="javascript:void(0)" class="skip-link" *ngIf="!generatorMode" (click)="skipServices()">
        Skip Services
      </a>
      <a href="javascript:void(0)" class="skip-link" *ngIf="generatorMode" (click)="closeMultipleVarientsPopup()">
        Cancel
      </a>

      <!-- All selected services configured → save (product-detail flow) or add to cart -->
      <button *ngIf="canAddToCartWithServices && addServiceMode" class="btn-done-variant" (click)="saveServicesAndReturn()">
        SAVE SERVICES <img src="/images/svg/forward.svg" alt="">
      </button>
      <button *ngIf="canAddToCartWithServices && generatorMode" class="btn-done-variant" (click)="onDone()">
        GENERATE SCHEMA <img src="/images/svg/forward.svg" alt="">
      </button>
      <button *ngIf="canAddToCartWithServices && !addServiceMode && !generatorMode" class="btn-done-variant" (click)="onDone()">
        ADD TO CART WITH SERVICES <img src="/images/svg/forward.svg" alt="">
      </button>

      <!-- Still services left to configure / add -->
      <button *ngIf="!canAddToCartWithServices" class="btn-done-variant"
        [disabled]="!hasAnyGroupServiceSelected()" [class.btn-done-disabled]="!hasAnyGroupServiceSelected()"
        (click)="configureGroupServices()">
        {{ selectedHasConfigurableUnconfigured ? 'CONFIGURE SERVICES' : 'CONFIGURE SERVICES' }} <img src="/images/svg/forward.svg" alt="">
      </button>
    </div>

    <!-- Separately Footer: tick service(s) → Configure Service; then ADD & CONTINUE -->
    <div class="drawer-footer mt-2 px-lg-4 pb-lg-4" *ngIf="serviceFlow === 'separately'">
      <a href="javascript:void(0)" class="skip-link" (click)="skipServices()">
        Skip Services
      </a>
      <button *ngIf="hasUnconfiguredSelectedServices()" class="btn-done-variant" (click)="configureGroupServices()">
        CONFIGURE SERVICE <img src="/images/svg/forward.svg" alt="">
      </button>
      <button *ngIf="!hasUnconfiguredSelectedServices()" class="btn-done-variant" [disabled]="!hasSavedServices"
        [class.btn-done-disabled]="!hasSavedServices" (click)="onDone()">
        ADD & CONTINUE
      </button>
    </div>

    }@else {
    <div class="configure-service h-100 d-flex flex-column overflow-hidden">
      <div class="scroll-area flex-grow-1 cut-card-scroll">
        <!-- Stepper (dynamic: Units & Services → Configure <svc>… → Review) -->
        <div class="configure-stepper-wrap">
          <div class="stepper-inner">
            <!-- Step: Units & Services (always done) -->
            <div class="stepper-step stepper-step--clickable"
              (click)="cameFromEditServices ? backToEditServices() : onContinueFromConfigure()">
              <div class="stepper-circle stepper-circle--filled"></div>
              <span class="stepper-label"><ng-container *ngIf="cameFromEditServices">Services</ng-container><ng-container *ngIf="!cameFromEditServices">Units<span class="stepper-full-label">&nbsp;&amp; Services</span></ng-container></span>
            </div>
  
            <!-- One step per service in the wizard -->
            <ng-container *ngFor="let svc of wizardServices; let si = index">
              <div class="stepper-line" [class.stepper-line--done]="si < wizardStep || isReviewStep"></div>
              <div class="stepper-step"
                [class.stepper-step--clickable]="canJumpToWizardStep(si)"
                (click)="canJumpToWizardStep(si) && loadWizardStep(si)">
                <div class="stepper-circle"
                  [class.stepper-circle--filled]="wizardCircleState(si) === 'filled'"
                  [class.stepper-circle--current]="wizardCircleState(si) === 'current'"
                  [class.stepper-circle--outline]="wizardCircleState(si) === 'outline'"></div>
                <span class="stepper-label"><span class="stepper-full-label">Configure </span>{{svc.name}}</span>
              </div>
            </ng-container>
  
            <!-- Review step (cut+bend together, or bending derived from a cut) -->
            <ng-container *ngIf="usesWizardReviewFlow">
              <div class="stepper-line" [class.stepper-line--done]="isReviewStep"></div>
              <div class="stepper-step"
                [class.stepper-step--clickable]="canJumpToReview"
                (click)="goToReviewStep()">
                <div class="stepper-circle"
                  [class.stepper-circle--current]="isReviewStep"
                  [class.stepper-circle--outline]="!isReviewStep"></div>
                <span class="stepper-label">Review</span>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- Auto-added confirmation (e.g. Punching) — fades after 4s or first action -->
        <div *ngIf="showAutoAddedBanner && !isReviewStep"
          class="d-flex justify-content-center align-items-center gap-2 text-muted small px-4 mt-4 mb-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          {{autoAddedBannerText}}
        </div>
        <!-- Centered title -->
        <div class="configure-title-row text-center px-4 mb-3 mt-3" *ngIf="!isReviewStep">
          <h3 class="fw-bold configure-heading m-0">
            Configure {{selectedService?.name}}<ng-container *ngIf="cameFromEditServices && editingVariant?.product">
              <span class="configure-heading-attrs">
                @for (attr of editingVariant.product.attributeSelector | keyvalue; track attr.key) {
                  @for (val of $any(attr.value); track val.attributeValue) {
                    @if (isAttributeActive(val, editingVariant.product)) {
                      <span class="attr-text"> &bull; {{val.attributeValue}}</span>
                    }
                  }
                }
              </span></ng-container>
          </h3>
          <div class="config-group-subtitle" *ngIf="activeGroupId && serviceFlow !== 'together'">
            {{getActiveGroupLabel()}} &bull; {{draftConfig?.qty}} OF {{flattenedSplitItems.length}} UNITS
          </div>
        </div>
        <div class="configure-title-row text-center px-4 mb-3 mt-3" *ngIf="isReviewStep">
          <h3 class="fw-bold configure-heading m-0">Review</h3>
          <div class="config-group-subtitle" *ngIf="activeGroupId && serviceFlow !== 'together'">
            {{getActiveGroupLabel()}} &bull; {{draftConfig?.qty}} OF {{flattenedSplitItems.length}} UNITS
          </div>
        </div>
           @if (isReviewStep) {
        <!-- ══ REVIEW STEP ══════════════════════════════════════════ -->
        <div class="cut-card review">
          <div class="review-section pb-4">

            <h5 class="fw-bold mb-3">Configured Services</h5>

            <!-- One review card per configured service -->
            <div class="review-service-card mb-3" *ngFor="let svc of wizardServices">
              <ng-container *ngIf="wizardDrafts[svc.name] as d">

                <!-- Card header -->
                <div class="review-card-header d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center gap-2">
                    <img [src]="d.img" alt="" class="review-svc-icon">
                    <h6 class="m-0 review-serv-name">{{d.name}}</h6>
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <span class="review-svc-price">
                      {{calcServiceTotal(d) | currency: 'USD'}}
                      <span *ngIf="d.name === 'Bending'">({{totalBendsFor(d)}} bend{{totalBendsFor(d) !== 1 ? 's' : ''}})</span>
                      <span *ngIf="d.name !== 'Bending'">({{generatedPiecesFor(d).length}} cut{{generatedPiecesFor(d).length !== 1 ? 's' : ''}})</span>
                    </span>
                  </div>
                </div>

                <!-- CUTTING review body -->
                <ng-container *ngIf="d.name !== 'Bending'">
                  <div class="review-block">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <p class="review-block-title">Measurements</p>
                      <a href="javascript:void(0)" class="review-edit-link" (click)="editWizardService(d.name)">Edit</a>
                    </div>

                    <div class="review-table">
                      <div class="review-tr review-tr--cut review-th">
                        <span></span><span>WIDTH (IN)</span><span>LENGTH (IN)</span><span class="text-center">QTY</span>
                      </div>
                      <div class="review-tr review-tr--cut" *ngFor="let m of d.measurements; let mi = index">
                        <span class="review-cut-letter">{{getLetter(mi)}}</span>
                        <span>{{m.width}} in</span>
                        <span>{{m.length}} in</span>
                        <span class="text-center">{{m.qty}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="review-block">
                    <p class="review-block-title mb-2">Generated Pieces</p>
                    <div class="pieces-grid">
                      <div class="piece-card" *ngFor="let p of generatedPiecesFor(d)">
                        <div class="piece-label">{{p.label}}</div>
                        <div class="piece-dims">{{p.width}} in x {{p.length}} in</div>
                      </div>
                    </div>
                  </div>

                  <!-- Include Remaining Material (read-only summary) -->
                  <div class="review-remaining d-flex align-items-center gap-2">
                    <svg class="review-remaining-check" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    <span>{{ includeRemainingMaterial ? 'Include Remaining Material' : 'Do Not Include Remaining Material' }}</span>
                  </div>
                </ng-container>

                <!-- BENDING review body -->
                <ng-container *ngIf="d.name === 'Bending'">
                  <!-- piece selector (view-only) — only when there is more than one piece;
                       a single piece needs no selection, just its measurements -->
                  <div class="pieces-grid bend-review mb-3" *ngIf="d.pieces?.length > 1">
                    <div class="piece-card piece-card--selectable"
                      *ngFor="let p of d.pieces; let pi = index"
                      [class.piece-card--active]="reviewBendPieceIndex === pi"
                      (click)="reviewBendPieceIndex = pi">
                      <div class="piece-label fw-bold">{{p.label}}</div>
                      <div class="piece-bend-badge" [class.piece-bend-badge--has]="bendCount(p)">
                        <img *ngIf="bendCount(p)" src="/images/svg/blue-tick.svg" alt="" class="piece-bend-tick">
                        {{bendBadge(p)}}
                      </div>
                    </div>
                  </div>

                  <div class="review-block">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <p class="review-block-title">Measurements</p>
                      <a href="javascript:void(0)" class="review-edit-link" (click)="editWizardService(d.name)">Edit</a>
                    </div>
                    <div class="review-table">
                      <div class="review-tr review-th review-tr--bend">
                       <span></span> <span>DISTANCE (IN)</span><span>DIRECTION</span><span class="text-center">ANGLE (°)</span>
                      </div>
                      <div class="review-tr review-tr--bend"
                        *ngFor="let r of (d.pieces?.length ? d.pieces[d.pieces.length > 1 ? reviewBendPieceIndex : 0]?.bendRows : d.bendRows); let ri = index">
                        <span class="text-center">{{ri + 1}}</span>
                        <span>{{r.distance || '0'}} in</span>
                        <span class="review-bend-dir">
                          <img [src]="r.direction === 'down' ? '/images/svg/down.svg' : '/images/svg/up.svg'" alt="" class="review-dir-icon me-1">
                          {{ r.direction === 'down' ? 'DOWN' : 'UP' }}
                        </span>
                        <span class="text-center">{{r.useCustom ? r.customAngle : r.angle}}°</span>
                      </div>
                    </div>
                  </div>

                  <div class="review-meta-table">
                    <div class="review-meta-row" *ngIf="bendPresetForDraft(d)">
                      <span class="review-meta-label">Shape Preset</span>
                      <span class="review-meta-value">{{bendPresetForDraft(d)}}</span>
                    </div>
                    <div class="review-meta-row" *ngIf="selectedProductForNewConfig?.width">
                      <span class="review-meta-label">Formed Length</span>
                      <span class="review-meta-value">{{selectedProductForNewConfig.width}}"</span>
                    </div>
                    <div class="review-meta-row" *ngIf="d.uploadedFile?.name">
                      <span class="review-meta-label">Sketch Attached</span>
                      <span class="review-meta-value summary-file">
                        <img src="./pdf-icon.svg" alt="" style="width:14px;opacity:0.6;margin-right:4px;">{{d.uploadedFile.name}}
                      </span>
                    </div>
                    <div class="review-meta-row" *ngIf="selectedProductForNewConfig?.outsideMaterial">
                      <span class="review-meta-label">Outside Material</span>
                      <span class="review-meta-value">{{selectedProductForNewConfig.outsideMaterial}}</span>
                    </div>
                    <div class="review-meta-row" *ngIf="d.notes?.trim()">
                      <span class="review-meta-label">Additional Notes</span>
                      <span class="review-meta-value">{{d.notes}}</span>
                    </div>
                  </div>
                </ng-container>

              </ng-container>
            </div>

            <!-- Price Summary -->
            <div class="review-price-summary mt-4">
              <h5 class="mb-3">Price Summary</h5>
              <div class="review-price-row" *ngFor="let svc of wizardServices">
                <span>{{svc.name}} Subtotal</span>
                <span>{{calcServiceTotal(wizardDrafts[svc.name]) | currency: 'USD'}}</span>
              </div>
              <div class="review-price-row review-price-total">
                <span>Total</span>
                <span>{{wizardGrandTotal | currency: 'USD'}}</span>
              </div>
            </div>

          </div>
        </div>
        
        } @else if (draftConfig && !draftConfig?.isSaved) {
        <div class="cut-card" (click)="dismissAutoAddedBanner()">
          <div class="specifications-section pb-4">

            <!-- ── BENDING CONFIGURE UI ─────────────────────────────── -->
            <ng-container *ngIf="selectedService?.name === 'Bending'">

              <!-- Generated Pieces selector (only when bending follows cutting) -->
              <div class="bend-pieces-section mb-4" *ngIf="draftConfig?.pieces?.length">
                <div class="d-flex justify-content-between align-items-start mb-1">
                  <h5 class="mb-0">Generated Pieces</h5>
                </div>
                <p class="text-muted small mb-3">Select a piece to apply bends.</p>
                  <a href="javascript:void(0)" class="select-all-link pt-2" (click)="selectAllPieces()">Select All</a>

                <div class="mt-3 pieces-grid bend-review">
                  <div class="piece-card piece-card--selectable"
                    *ngFor="let p of draftConfig.pieces; let pi = index"
                    [class.piece-card--active]="selectedPieceIndex === pi"
                    (click)="selectBendPiece(pi)">
                    <div class="piece-label fw-bold">{{p.label}}</div>
                    <div class="piece-dims">{{p.width}} in x {{p.length}} in</div>
                    <div class="piece-qty">Qty {{p.qty}}</div>
                    <div class="piece-bend-badge"
                      [class.piece-bend-badge--has]="bendCount(p)">
                      <img *ngIf="bendCount(p)" src="/images/svg/blue-tick.svg" alt="" class="piece-bend-tick">
                      {{bendBadge(p)}}
                    </div>
                  </div>
                </div>
                <hr class="bend-pieces-divider mt-4">
              </div>

              <!-- Bend editing UI: shown only after a piece is selected (or standalone bending) -->
              <ng-container *ngIf="activeBend">

              <div class="sec-header sec-header--bend-meas">
                <h5 class="mb-0">Measurements</h5>
                <p class="mb-0">Choose a preset bend profile or create your own</p>
              </div>

              <div class="bend-profile-block">
                <div class="bend-profile-group">
                <div class="bend-mode-toggle" role="group" aria-label="Bend profile mode">
                  <button type="button" class="bend-mode-btn" [class.active]="bendProfileMode === 'preset'"
                    (click)="setBendProfileMode('preset')">Preset</button>
                  <button type="button" class="bend-mode-btn" [class.active]="bendProfileMode === 'custom'"
                    (click)="setBendProfileMode('custom')">Custom</button>
                </div>

                <div class="bend-profile-field" *ngIf="bendProfileMode === 'preset'">
                  <p class="bend-profile-label">Bend Profile</p>
                  <div class="bend-profile-select" (click)="$event.stopPropagation()">
                    <button type="button" class="bend-profile-trigger"
                      (click)="bendProfileOpen = !bendProfileOpen">
                      <!-- NB: not "placeholder" — that's a Bootstrap utility that paints a grey block. -->
                      <span class="bend-profile-value" [class.is-placeholder]="!selectedBendProfile">
                        {{ selectedBendProfile || 'Select profile...' }}
                      </span>
                      <img class="bend-profile-caret rotate90" src="/images/svg/dropdown.svg" alt="">
                    </button>
                    <ul class="bend-profile-menu" *ngIf="bendProfileOpen">
                      <li *ngFor="let profile of bendProfileOptions">
                        <button type="button" class="bend-profile-option"
                          [class.selected]="selectedBendProfile === profile"
                          (click)="selectBendProfile(profile)">{{ profile }}</button>
                      </li>
                    </ul>
                  </div>
                </div>
                </div>

                <div class="bend-option-group" *ngIf="selectedBendProfile === 'Molding'">
                  <p class="bend-option-label">Common sizes (Optional)</p>
                  <div class="bend-option-pills">
                    <button type="button" class="bend-pill" [class.active]="moldingSize === '1in'"
                      (click)="setCommonSize('molding', '1in')">1 in</button>
                    <button type="button" class="bend-pill" [class.active]="moldingSize === '2in'"
                      (click)="setCommonSize('molding', '2in')">2 in</button>
                    <button type="button" class="bend-pill" [class.active]="moldingSize === 'lightbox'"
                      (click)="setCommonSize('molding', 'lightbox')">Light Box</button>
                 
                    <button type="button" class="bend-pill" [class.active]="moldingSize === 'reverse'"
                      (click)="setCommonSize('molding', 'reverse')">Reverse</button>
                  </div>

                  <p class="bend-size-warning" *ngIf="commonSizeFitWarning">{{ commonSizeFitWarning }}</p>
                </div>

                <ng-container *ngIf="isChannelRaceway">
                  <div class="bend-option-group">
                    <p class="bend-option-label">Common sizes (Optional)</p>
                    <div class="bend-option-pills">
                      <button type="button" class="bend-pill" [class.active]="racewaySize === '5x5'"
                        (click)="setCommonSize('raceway', '5x5')">5 in X 5 in</button>
                      <button type="button" class="bend-pill" [class.active]="racewaySize === '5x8'"
                        (click)="setCommonSize('raceway', '5x8')">5 in X 8 in</button>
                    </div>

                  <p class="bend-size-warning" *ngIf="commonSizeFitWarning">{{ commonSizeFitWarning }}</p>
                  </div>

                  <label class="bend-check">
                    <input type="checkbox" class="bend-check-input" [checked]="includeCover"
                      (change)="setIncludeCover(!includeCover)">
                    <span class="bend-check-box" aria-hidden="true">
                      <img *ngIf="includeCover" src="/images/svg/check-bold-white.svg" alt="" width="12" height="12">
                    </span>
                    <span class="bend-check-label">Include Cover</span>
                  </label>
                </ng-container>

                <ng-container *ngIf="selectedBendProfile === 'Siding'">
                  <div class="bend-option-group">
                    <p class="bend-option-label">Siding Type</p>
                    <div class="bend-option-pills">
                      <button type="button" class="bend-pill" [class.active]="sidingType === 'regular'"
                        (click)="setSidingType('regular')">Regular</button>
                      <button type="button" class="bend-pill" [class.active]="sidingType === 'chaser'"
                        (click)="setSidingType('chaser')">Chaser</button>
                    </div>
                  </div>


                  <div class="bend-option-group">
                    <p class="bend-option-label">Sides</p>
                    <div class="bend-option-tags">
                      <button type="button" class="bend-tag" [class.active]="sidingSides === 1"
                        (click)="setSidingSides(1)">1-sided</button>
                      <button type="button" class="bend-tag" [class.active]="sidingSides === 2"
                        (click)="setSidingSides(2)">2-sided</button>
                    </div>
                  </div>

                  <div class="bend-option-group" *ngIf="sidingSizeOptions.length">
                    <p class="bend-option-label">Common sizes (Optional)</p>
                    <div class="bend-option-pills">
                      <button type="button" class="bend-pill" *ngFor="let size of sidingSizeOptions"
                        [class.active]="sidingSize === size"
                        (click)="setCommonSize('siding', size)">{{ optionText(size) }}</button>
                    </div>
                    <p class="bend-size-warning" *ngIf="commonSizeFitWarning">{{ commonSizeFitWarning }}</p>
                  </div>
                </ng-container>
              </div>

              <!-- Static section: stays on screen from the empty state on, so it is
                   NOT gated on a profile being picked. A square piece has nothing to
                   choose between, so its tags show disabled rather than hidden. -->
              <div class="bend-edge-block">
                <div class="bend-edge-copy">
                  <p class="bend-edge-title">Measure bends from</p>
                  <p class="bend-edge-sub">Choose which edge the bend distances are measured from.</p>
                </div>
                <div class="bend-edge-tags">
                  <button type="button" class="bend-edge-tag" [class.active]="bendAxis === 'width'"
                    [disabled]="!canChooseBendSide"
                    (click)="setBendAxis('width')">Width ({{ bendSideWidth }} in)</button>
                  <button type="button" class="bend-edge-tag" [class.active]="bendAxis === 'length'"
                    [disabled]="!canChooseBendSide"
                    (click)="setBendAxis('length')">Length ({{ bendSideLength }} in)</button>
                </div>
              </div>

              <!-- Column headers -->
              <div class="row g-2 align-items-end col-headers-row">
                <div class="col-auto col-header-spacer-start"></div>
                <div class="col">
                  <div class="col-header-label">DISTANCE (IN)<span class="text-danger">*</span></div>
                </div>
                <div class="col">
                  <div class="col-header-label text-center">DIRECTION</div>
                </div>
                <div class="col">
                  <div class="col-header-label text-center">ANGLE (°)</div>
                </div>
                <!-- Trailing spacer only exists to balance the delete column, so it goes
                     with it in Preset mode — per Figma the three columns fill the row. -->
                <div class="col-auto col-header-spacer-end" *ngIf="!bendRowsLocked"></div>
              </div>

              <!-- Bend rows -->
              <!-- meas-mobile-box: bordered card group (mobile only; display:contents on desktop) -->
              <div class="meas-mobile-box">
              <!-- Mobile only: the "inches/degrees" hint sits INSIDE the box (desktop keeps it in .sec-header). -->
              <p class="meas-box-hint">Inches for distances. Degrees for angles.</p>

              <!-- Static section: the table (header row + this box) stays visible in its
                   empty state. In Preset mode the rows are generated BY the profile, so
                   until one is picked the box holds just this line — no bend rows and no
                   Add/Clear controls. -->
              <p class="bend-empty-hint" *ngIf="showBendProfilePrompt">
                Select a preset profile to generate bend measurements.
              </p>

              <ng-container *ngIf="!showBendProfilePrompt">
              <div class="measurements-list">
               
                <p class="bend-group-label" *ngIf="isChannelRaceway">Channel Raceway</p>
                <ng-container *ngFor="let row of activeBend?.bendRows; let i = index">
                  <ng-container
                    *ngTemplateOutlet="bendRowTpl; context: { $implicit: row, index: i }"></ng-container>
                </ng-container>

                <div class="row align-items-center meas-row" [class.meas-row--no-del]="bendRowsLocked"
                  *ngIf="showEndFlange">
                  <div class="col-auto ps-lg-1 text-center bend-row-num">Line {{ bendLineCount }}</div>
                  <div class="col">
                    <span class="meas-mobile-label">Distance (in)</span>
                    <div class="measurement-control measurement-control--input">
                      <input type="number" class="measurement-input" [ngModel]="endFlange"
                        (ngModelChange)="onEndFlangeChange($event)" placeholder="Closing length">
                      <span class="measurement-unit" *ngIf="endFlange">IN</span>
                    </div>
                  </div>
                  <div class="col"><span class="bend-end-note">No bend — closing length</span></div>
                  <div class="col"></div>
                  <div class="col-auto bend-del-col" style="width:36px;" *ngIf="!bendRowsLocked"></div>
                </div>

                <ng-container *ngIf="showCoverSection">
                  <div class="bend-group-divider"></div>
                  <p class="bend-group-label">Cover</p>
                  <ng-container *ngFor="let row of coverBendRows; let i = index">
                    <ng-container
                      *ngTemplateOutlet="bendRowTpl; context: { $implicit: row, index: i, cover: true }"></ng-container>
                  </ng-container>

                  <!-- The cover closes on its own line too (N bends = N+1 lines). -->
                  <div class="row align-items-center meas-row" [class.meas-row--no-del]="bendRowsLocked"
                    *ngIf="showCoverEndFlange">
                    <div class="col-auto ps-lg-1 text-center bend-row-num">Line {{ coverLineCount }}</div>
                    <div class="col">
                      <span class="meas-mobile-label">Distance (in)</span>
                      <div class="measurement-control measurement-control--input">
                        <input type="number" class="measurement-input" [ngModel]="coverEndFlange"
                          (ngModelChange)="onCoverEndFlangeChange($event)" placeholder="Closing length">
                        <span class="measurement-unit" *ngIf="coverEndFlange">IN</span>
                      </div>
                    </div>
                    <div class="col"><span class="bend-end-note">No bend — closing length</span></div>
                    <div class="col"></div>
                    <div class="col-auto bend-del-col" style="width:36px;" *ngIf="!bendRowsLocked"></div>
                  </div>
                </ng-container>
              </div>

              <ng-template #bendRowTpl let-row let-i="index" let-cover="cover">
                <div class="row align-items-center meas-row" [class.meas-row--no-del]="bendRowsLocked">

                  <!-- Row label -->
                  <div class="col-auto ps-lg-1 text-center bend-row-num">Bend {{i + 1}}</div>

                  <!-- Distance -->
                  <div class="col">
                    <span class="meas-mobile-label">Distance (in) <span class="meas-req">*</span></span>
                    <div class="measurement-control measurement-control--input">
                      <input type="number" class="measurement-input" [(ngModel)]="row.distance"
                        (ngModelChange)="cover ? onCoverDistanceChange(row) : onBendDistanceChange(row)"
                        placeholder="Distance from left">
                      <span class="measurement-unit" *ngIf="row.distance">IN</span>
                    </div>
                  </div>

                  <!-- Direction -->
                  <div class="col">
                    <span class="meas-mobile-label">Direction <span class="meas-req">*</span></span>
                    <div class="direction-toggle">
  <!-- Slider only appears once a direction is chosen (default: nothing selected). -->
  <div class="toggle-slider" *ngIf="row.direction === 'up' || row.direction === 'down'"
    [class.down]="row.direction === 'down'"></div>

  <button
    type="button"
    class="dir-btn"
    [class.active]="row.direction === 'up'"
    (click)="row.direction = 'up'">
  
    <img
      [src]="row.direction === 'up'
        ? '/images/svg/up.svg'
        : '/images/svg/light-up.svg'"
      alt="Up"
      class="dir-icon">
    <span>UP</span>
  </button>

  <button
    type="button"
    class="dir-btn"
    [class.active]="row.direction === 'down'"
    (click)="row.direction = 'down'">
     <img
      [src]="row.direction === 'down'
        ? '/images/svg/down.svg'
        : '/images/svg/light-down.svg'"
      alt="Down"
      class="dir-icon">
    <span>DOWN</span>
  </button>
                   </div>
                  </div>

                  <!-- Angle. Wrapped in .col like Distance and Direction: on mobile the
                       stacking rules key off `.meas-row > .col`, so as a bare child this
                       field got no full-width treatment and no 12px gap. The label is
                       display:none on desktop, so the grid still sees exactly 5 items. -->
                  <div class="col">
                  <span class="meas-mobile-label">Angle (°)</span>
                  <div class="angle-toggle">

  <!-- Slider only appears once an angle is chosen (default: nothing selected). -->
  <div
    *ngIf="row.useCustom || row.angle === 45 || row.angle === 90"
    class="angle-slider"
    [ngClass]="{
      'pos-45': !row.useCustom && row.angle === 45,
      'pos-90': !row.useCustom && row.angle === 90,
      'pos-custom': row.useCustom
    }">
  </div>

  <!-- 45° -->
  <button
    type="button"
    class="angle-btn"
    [class.active]="!row.useCustom && row.angle === 45"
    (click)="cover ? selectCoverBendAngle(i, 45) : selectBendAngle(i, 45)">

    <svg style="transform: rotate(90deg);" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <line x1="2" y1="20" x2="20" y2="2"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round"/>
      <line x1="20" y1="2" x2="20" y2="20"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round"/>
    </svg>
  </button>

  <!-- 90° -->
  <button
    type="button"
    class="angle-btn"
    [class.active]="!row.useCustom && row.angle === 90"
    (click)="cover ? selectCoverBendAngle(i, 90) : selectBendAngle(i, 90)">

    <svg style="transform: rotate(270deg);" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <line x1="2" y1="20" x2="2" y2="2"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round"/>
      <line x1="2" y1="20" x2="20" y2="20"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round"/>
    </svg>
  </button>

  <!-- Custom -->
  <button
    type="button"
    class="angle-btn custom-btn"
    [class.active]="row.useCustom"
    (click)="cover ? selectCoverBendAngle(i, 'custom') : selectBendAngle(i, 'custom')">

    <ng-container *ngIf="row.useCustom">
      <input
        type="number"
        class="custom-angle-input"
        min="35"
        max="135"
        [(ngModel)]="row.customAngle"
        (click)="$event.stopPropagation()"
        (blur)="clampCustomAngle(row)">
    </ng-container>

    <ng-container *ngIf="!row.useCustom">
      Custom
    </ng-container>

  </button>

</div>
                  </div><!-- /.col (Angle) -->

                  <!-- Delete. Custom mode only — a preset's rows come from the profile, so
                       the whole column drops out and the row fills the width, as in Figma. -->
                  <div class="col-auto d-flex align-items-center bend-del-col" style="width:36px;"
                    *ngIf="!bendRowsLocked">
                    <button class="meas-del-btn"
                      (click)="cover ? removeCoverBendRow(i) : removeBendRow(i)">
                      <img src="/images/svg/delete.svg" alt="remove" class="meas-del-icon">
                    </button>
                  </div>
                </div>
              </ng-template>

              <!-- ADD BEND / CLEAR ALL — Custom mode only, per Figma. -->
              <div class="add-cut-row mt-3" *ngIf="!bendRowsLocked">
                <button class="btn-add-cut" (click)="addBendRow()">+ ADD BEND</button>
                <button class="btn-clear-all ms-3" (click)="clearBendRows()">CLEAR ALL</button>
              </div>
              </ng-container>
              </div><!-- /meas-mobile-box (bending) -->

              <!-- Cross-Section Preview -->
              <div class="bend-preview-wrap mt-4" [class.bend-preview-collapsed]="!bendPreviewOpen">
                <h5 class="bend-preview-head text-center mb-3" (click)="bendPreviewOpen = !bendPreviewOpen">
                  <span>Cross-Section Preview</span>
                  <svg class="bend-preview-chevron" [class.open]="bendPreviewOpen" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </h5>

                <!-- Info chips (always visible) -->
                <div class="d-flex flex-wrap gap-2 mb-2">
                  <span class="bend-info-chip" *ngIf="draftConfig?.pieces?.length">Piece {{activeBend?.label}}</span>
                  <span class="bend-info-chip">{{previewBendCount}} Bend{{previewBendCount !== 1 ? 's' : ''}}</span>
                  <span class="bend-info-chip" *ngIf="bendTotalLength">Total Length: {{ bendTotalLength }} IN</span>
                  <span class="bend-info-chip" *ngIf="selectedProductForNewConfig?.outsideMaterial">Outside Material: {{selectedProductForNewConfig.outsideMaterial}}</span>
                </div>

                <!-- Canvas area -->
                <div class="bend-canvas-outer" [class.is-empty]="!bendSVGData">
                  <!-- FORMED / FLAT toggle -->
                  <div class="bend-view-toggle">
                    <button class="bend-view-btn" [class.active]="bendViewMode === 'formed'"
                      [disabled]="!bendCount(activeBend)"
                      (click)="bendCount(activeBend) && (bendViewMode = 'formed')">FORMED</button>
                    <button class="bend-view-btn" [class.active]="bendViewMode === 'flat'"
                      (click)="bendViewMode = 'flat'">FLAT</button>
                  </div>

                  <!-- Empty state -->
                  <div class="bend-canvas-empty" *ngIf="!bendSVGData">
                    <div class="bend-empty-line-wrap">
                      <span class="bend-empty-dim">{{ bendTotalLength || getProductLengthInInches() }}"</span>
                      <div class="bend-empty-line"></div>
                    </div>
                    <p class="bend-empty-msg">Preview updates as Bends are added</p>
                  </div>

                  <!-- Filled state: SVG diagram -->
                  <div class="bend-canvas-filled" *ngIf="bendSVGData as svg">

                    <!-- FORMED VIEW -->
                    <svg *ngIf="bendViewMode === 'formed'" class="bend-svg" [style.height.px]="svg.height"
                      [attr.viewBox]="svg.viewBox" xmlns="http://www.w3.org/2000/svg">
                      <!-- Bend path (with angles) -->
                      <path [attr.d]="svg.path"
                        fill="none" stroke="#111827" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round"/>
                      <!-- Cover: its own outline, drawn above the channel it caps -->
                      <path *ngIf="svg.coverPath" [attr.d]="svg.coverPath"
                        fill="none" stroke="#111827" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round"/>
                      <!-- Which outline is which (only drawn when there are two) -->
                      <ng-container *ngFor="let sl of svg.shapeLabels">
                        <line [attr.x1]="sl.x1" [attr.y1]="sl.y" [attr.x2]="sl.x2" [attr.y2]="sl.y"
                          stroke="#6B7280" stroke-width="1"/>
                        <text [attr.x]="sl.tx" [attr.y]="sl.ty" text-anchor="end"
                          class="bend-shape-label">{{sl.text}}</text>
                      </ng-container>
                      <!-- Segment distance labels (rotated with segment) -->
                      <ng-container *ngFor="let seg of svg.segLabels">
                        <text *ngIf="seg.dist"
                          [attr.x]="seg.x" [attr.y]="seg.y"
                          fill="#6B7280" font-size="11" text-anchor="middle">{{seg.dist}}</text>
                      </ng-container>
                      <!-- Bend point dots + labels (placed on the outside of each bend) -->
                      <ng-container *ngFor="let bp of svg.bendPoints">
                        <g class="bend-point-group" [class.bend-point-glow]="glowingBendIndex === bp.key"
                          (click)="onBendTagClick(bp.key)">
                          <circle [attr.cx]="bp.x" [attr.cy]="bp.y" r="5.5" fill="#57A9D0"/>
                          <text [attr.x]="bp.lx" [attr.y]="bp.ly"
                            [attr.text-anchor]="bp.anchor" class="bend-label-text">{{bp.label}}</text>
                          <text [attr.x]="bp.lx" [attr.y]="bp.ly + 18"
                            [attr.text-anchor]="bp.anchor" class="bend-deg-text">
                            {{bp.dir === 'down' ? '↓' : '↑'}} {{bp.angle}}°
                          </text>
                        </g>
                      </ng-container>
                      <!-- Cover segment dimensions + bend tags (numbered from Bend 1 again) -->
                      <ng-container *ngFor="let seg of svg.coverSegLabels">
                        <text *ngIf="seg.dist"
                          [attr.x]="seg.x" [attr.y]="seg.y"
                          fill="#6B7280" font-size="11" text-anchor="middle">{{seg.dist}}</text>
                      </ng-container>
                      <ng-container *ngFor="let bp of svg.coverBendPoints">
                        <g class="bend-point-group" [class.bend-point-glow]="glowingBendIndex === bp.key"
                          (click)="onBendTagClick(bp.key)">
                          <circle [attr.cx]="bp.x" [attr.cy]="bp.y" r="5.5" fill="#57A9D0"/>
                          <text [attr.x]="bp.lx" [attr.y]="bp.ly"
                            [attr.text-anchor]="bp.anchor" class="bend-label-text">{{bp.label}}</text>
                          <text [attr.x]="bp.lx" [attr.y]="bp.ly + 18"
                            [attr.text-anchor]="bp.anchor" class="bend-deg-text">
                            {{bp.dir === 'down' ? '↓' : '↑'}} {{bp.angle}}°
                          </text>
                        </g>
                      </ng-container>
                    </svg>

                    <!-- FLAT VIEW (unfolded) -->
                    <svg *ngIf="bendViewMode === 'flat'" class="bend-svg" [style.height.px]="svg.flatHeight"
                      [attr.viewBox]="svg.flatViewBox" xmlns="http://www.w3.org/2000/svg">
                      <!-- Flat horizontal line (unfolded material) -->
                      <path [attr.d]="svg.flatPath"
                        fill="none" stroke="#111827" stroke-width="2.5"
                        stroke-linecap="round"/>
                      <!-- Cover unfolds as its own strip below the channel's -->
                      <path *ngIf="svg.flatCoverPath" [attr.d]="svg.flatCoverPath"
                        fill="none" stroke="#111827" stroke-width="2.5"
                        stroke-linecap="round"/>
                      <text *ngFor="let sl of svg.flatShapeLabels"
                        [attr.x]="sl.x" [attr.y]="sl.y" text-anchor="start"
                        class="bend-shape-label">{{sl.text}}</text>
                      <!-- Segment distance labels (horizontal above line) -->
                      <ng-container *ngFor="let seg of svg.flatSegLabels">
                        <text *ngIf="seg.dist"
                          [attr.x]="seg.x" [attr.y]="seg.y"
                          fill="#6B7280" font-size="11" text-anchor="middle">{{seg.dist}}</text>
                      </ng-container>
                      <!-- Bend point markers (below line) -->
                      <ng-container *ngFor="let bp of svg.flatBendPoints">
                        <g class="bend-point-group" [class.bend-point-glow]="glowingBendIndex === bp.key"
                          (click)="onBendTagClick(bp.key)">
                          <!-- Flat view: mark the bend with a vertical tick (not a dot) -->
                          <line [attr.x1]="bp.x" [attr.y1]="bp.y - 7" [attr.x2]="bp.x" [attr.y2]="bp.y + 7"
                            stroke="#57A9D0" stroke-width="2.5" stroke-linecap="round"/>
                          <text [attr.x]="bp.x" [attr.y]="bp.ly"
                            text-anchor="middle" class="bend-label-text">{{bp.label}}</text>
                          <text [attr.x]="bp.x" [attr.y]="bp.ly + 16"
                            text-anchor="middle" class="bend-deg-text">
                            {{bp.dir === 'down' ? '↓' : '↑'}} {{bp.angle}}°
                          </text>
                        </g>
                      </ng-container>
                      <ng-container *ngFor="let seg of svg.flatCoverSegLabels">
                        <text *ngIf="seg.dist"
                          [attr.x]="seg.x" [attr.y]="seg.y"
                          fill="#6B7280" font-size="11" text-anchor="middle">{{seg.dist}}</text>
                      </ng-container>
                      <ng-container *ngFor="let bp of svg.flatCoverBendPoints">
                        <g class="bend-point-group" [class.bend-point-glow]="glowingBendIndex === bp.key"
                          (click)="onBendTagClick(bp.key)">
                          <line [attr.x1]="bp.x" [attr.y1]="bp.y - 7" [attr.x2]="bp.x" [attr.y2]="bp.y + 7"
                            stroke="#57A9D0" stroke-width="2.5" stroke-linecap="round"/>
                          <text [attr.x]="bp.x" [attr.y]="bp.ly"
                            text-anchor="middle" class="bend-label-text">{{bp.label}}</text>
                          <text [attr.x]="bp.x" [attr.y]="bp.ly + 16"
                            text-anchor="middle" class="bend-deg-text">
                            {{bp.dir === 'down' ? '↓' : '↑'}} {{bp.angle}}°
                          </text>
                        </g>
                      </ng-container>
                    </svg>

                  </div>
                </div>

                <!-- Legend chips (bend tags) — outside the canvas, clickable to glow the bend.
                     Short "B1" form so a raceway's many bends still fit on one row, and
                     split per outline once the cover has its own bends. -->
                <ng-container *ngIf="bendSVGData as svg">
                  <p class="bend-legend-group-label" *ngIf="svg.hasCover">{{selectedBendProfile}}</p>
                  <div class="bend-legend-row mt-2">
                    <span class="bend-legend-chip bend-tag-clickable" *ngFor="let bp of svg.bendPoints"
                      (click)="onBendTagClick(bp.key)" [class.bend-tag-glow]="glowingBendIndex === bp.key">
                      {{bp.tag}} · {{bp.dir === 'down' ? '↓' : '↑'}} {{bp.angle}}°
                    </span>
                  </div>
                  <ng-container *ngIf="svg.coverBendPoints.length">
                    <p class="bend-legend-group-label">Cover</p>
                    <div class="bend-legend-row mt-2">
                      <span class="bend-legend-chip bend-tag-clickable" *ngFor="let bp of svg.coverBendPoints"
                        (click)="onBendTagClick(bp.key)" [class.bend-tag-glow]="glowingBendIndex === bp.key">
                        {{bp.tag}} · {{bp.dir === 'down' ? '↓' : '↑'}} {{bp.angle}}°
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

              <!-- Attach sketch link — below the preview box -->
              <div class="text-center mt-3">
                <label class="attach-sketch-link" style="cursor: pointer;">
                  <span><img src="/images/svg/attach.svg" alt=""></span> Attach additional bending sketch
                  <input type="file" class="d-none" (change)="onFileSelected($event)">
                </label>
                <div *ngIf="draftConfig?.uploadedFile?.name"
                  class="attached-sketch-name d-flex align-items-center justify-content-center gap-2 mt-2">
                  <img src="./pdf-icon.svg" alt="" style="width:14px;opacity:0.6;">
                  <span class="file-name">{{ draftConfig.uploadedFile.name }}</span>
                  <a href="javascript:void(0)" class="text-danger" (click)="draftConfig.uploadedFile = null">✕</a>
                </div>
              </div>

              <!-- Additional Instructions — static section, visible from the empty state -->
              <div class="bend-additional-notes mt-4">
                <h5 class="mb-3">Additional Instructions</h5>
                <textarea class="additional-notes-input w-100" rows="3" [(ngModel)]="draftConfig.notes"
                  placeholder="Include any additional manufacturing notes or clarifications for the warehouse team..."></textarea>
              </div>

              <!-- Quick Summary — static section, visible from the empty state and
                   filled in live as the configuration is made. -->
              <div class="bend-quick-summary mt-4">
                <h5 class="mb-3">Quick Summary</h5>
                <div class="summary-table">

                  <div class="summary-row">
                    <span class="summary-label">Bend Profile</span>
                    <span class="summary-value">{{bendProfileLabel}}</span>
                  </div>

                  <div class="summary-row" *ngIf="commonSizeLabel">
                    <span class="summary-label">Common Size</span>
                    <span class="summary-value">{{commonSizeLabel}}</span>
                  </div>

                  <div class="summary-row" *ngIf="sidingTypeLabel">
                    <span class="summary-label">Siding Type</span>
                    <span class="summary-value">{{sidingTypeLabel}}</span>
                  </div>

                  <div class="summary-row" *ngIf="sidingSidesLabel">
                    <span class="summary-label">Sides</span>
                    <span class="summary-value">{{sidingSidesLabel}}</span>
                  </div>

                  <div class="summary-row">
                    <span class="summary-label">Total Bends</span>
                    <span class="summary-value">{{totalBendsFor(draftConfig)}}</span>
                  </div>

                  <div class="summary-row" *ngIf="isChannelRaceway">
                    <span class="summary-label">Cover</span>
                    <span class="summary-value">
                      {{ includeCover ? (coverBendCount + ' Bend' + (coverBendCount === 1 ? '' : 's')) : 'Not included' }}
                    </span>
                  </div>

                  <div class="summary-row">
                    <span class="summary-label">Measured From</span>
                    <span class="summary-value text-capitalize">{{bendAxis}}</span>
                  </div>

                  <div class="summary-row" *ngIf="selectedProductForNewConfig?.width">
                    <span class="summary-label">Formed Length</span>
                    <span class="summary-value">{{selectedProductForNewConfig.width}}"</span>
                  </div>

                  <div class="summary-row" *ngIf="draftConfig?.uploadedFile?.name">
                    <span class="summary-label">Sketch Attached</span>
                    <span class="summary-value summary-file">
                      <img src="./pdf-icon.svg" alt="" style="width:14px;opacity:0.6;margin-right:4px;">
                      {{draftConfig.uploadedFile.name}}
                    </span>
                  </div>

                  <div class="summary-row" *ngIf="selectedProductForNewConfig?.outsideMaterial">
                    <span class="summary-label">Outside Material</span>
                    <span class="summary-value">{{selectedProductForNewConfig.outsideMaterial}}</span>
                  </div>

                  <div class="summary-row" *ngIf="draftConfig?.notes?.trim()">
                    <span class="summary-label">Additional Instructions</span>
                    <span class="summary-value">{{draftConfig.notes}}</span>
                  </div>

                </div>
              </div>
              <!-- end bend editing UI -->
              </ng-container>

            </ng-container>
            <!-- ── END BENDING UI ──────────────────────────────────── -->

            <!-- ── CUTTING / OTHER SERVICES UI ───────────────────── -->
            <ng-container *ngIf="selectedService?.name !== 'Bending'">

            <!-- Section header -->
            <div class="sec-header">
              <h5 class="mb-1">Measurements</h5>
              <p class="mb-1">Define the pieces created from this material.</p>
              <p class="sec-header-info sec-header-info--cut mb-0">All measurements are in inches. Decimals or fractions supported (e.g. 12.5 or 12 1/2).</p>
            </div>

            <!-- Column headers -->
            <div class="row g-2 align-items-end col-headers-row">
              <div class="col-auto col-header-spacer-start"></div>
              <div class="col">
                <div class="col-header-label">WIDTH (IN)</div>
                <!-- <div class="col-header-hint">Allowed: 24-120 (e.g. 24, 36)</div> -->
              </div>
              <div class="col" *ngIf="selectedService?.name !== 'Slitting'">
                <div class="col-header-label">LENGTH (IN)</div>
                <!-- <div class="col-header-hint">Allowed: 2-48 (e.g. 2, 4, 8, 12)</div> -->
              </div>
              <div class="col">
                <div class="col-header-label">QTY</div>
                <!-- <div class="col-header-hint"></div> -->

              </div>
              <div class="col-auto col-bend-spacer-end"></div>
            </div>

            <!-- Measurement rows using existing classes -->
            <!-- meas-mobile-box: bordered card group (mobile only; display:contents on desktop) -->
            <div class="meas-mobile-box">
            <!-- Mobile only: the "inches" hint sits INSIDE the box (desktop keeps it in .sec-header). -->
            <p class="meas-box-hint">Inches only. Decimals and fractions supported.</p>
            <div class="measurements-list">
              <div class="row g-2 align-items-center meas-row"
                [class.meas-row--no-length]="selectedService?.name === 'Slitting'"
                *ngFor="let m of draftConfig?.measurements; let i = index">
                <!-- Letter label -->
                <div class="col-auto d-flex align-items-center justify-content-center meas-letter">
                  {{getLetter(i)}}
                </div>
                <!-- WIDTH (inches; decimals + fractions, arrow keys step by 1) -->
                <div class="col">
                  <span class="meas-mobile-label">Width (in)</span>
                  <div class="measurement-control measurement-control--input">
                    <input type="text" placeholder="Enter width" inputmode="text" autocomplete="off" aria-label="Width in inches"
                      [value]="getMeasurementDisplay(m, 'width')"
                      (keydown)="onMeasurementKeydown($event, m, 'width')"
                      (input)="onMeasurementInput($event, m, 'width')"
                      (blur)="onMeasurementBlur(m, 'width')"
                      class="measurement-input">
                    <span class="measurement-unit" *ngIf="getMeasurementDisplay(m, 'width')">IN</span>
                  </div>
                </div>
                <!-- LENGTH (inches; decimals + fractions, arrow keys step by 1) — not used for Slitting -->
                <div class="col" *ngIf="selectedService?.name !== 'Slitting'">
                  <span class="meas-mobile-label">Length (in)</span>
                  <div class="measurement-control measurement-control--input">
                    <input type="text" placeholder="Enter length" inputmode="text" autocomplete="off" aria-label="Length in inches"
                      [value]="getMeasurementDisplay(m, 'length')"
                      (keydown)="onMeasurementKeydown($event, m, 'length')"
                      (input)="onMeasurementInput($event, m, 'length')"
                      (blur)="onMeasurementBlur(m, 'length')"
                      class="measurement-input">
                    <span class="measurement-unit" *ngIf="getMeasurementDisplay(m, 'length')">IN</span>
                  </div>
                </div>
                <!-- QTY -->
                <div class="col">
                  <span class="meas-mobile-label">Qty</span>
                  <div class="measurement-control qty">
                    <button type="button" tabindex="-1" class="measurement-btn" (click)="adjustMeasurement(i, 'qty', -1)">&minus;</button>
                    <input type="number" [(ngModel)]="m.qty" class="measurement-input text-center">
                    <button type="button" tabindex="-1" class="measurement-btn" (click)="adjustMeasurement(i, 'qty', 1)">&plus;</button>
                  </div>
                </div>
                <!-- Delete -->
                <div class="col-auto d-flex justify-content-center align-items-center meas-del-col">
                  <button type="button" tabindex="-1" class="meas-del-btn" (click)="removeMeasurement(i)">
                    <img src="/images/svg/delete.svg" alt="remove" class="meas-del-icon">
                  </button>
                </div>
              </div>
            </div>

            <!-- ADD CUT / CLEAR ALL -->
            <div class="add-cut-row mt-3">
              <!-- [disabled]="isMaterialFullyAllocated" -->
              <button class="btn-add-cut"  (click)="addMeasurement()">
                + ADD {{ (getInternalQtyLabel(selectedService) || 'cut') | uppercase }}
              </button>
              <button class="btn-clear-all ms-3" (click)="clearAllMeasurements()">CLEAR ALL</button>
            </div>
            </div><!-- /meas-mobile-box -->
            <!-- <div class="material-full-msg small text-muted mt-1 mb-2" *ngIf="isMaterialFullyAllocated">
              All available material has been allocated. To add another cut, edit or remove an existing cut.
            </div> -->

            <!-- Generated Pieces -->
            <div class="generated-pieces-section mt-4" *ngIf="generatedPieces.length">
              <h5 class="mb-3">Generated Pieces</h5>
              <div class="pieces-grid">
                <div class="piece-card" *ngFor="let piece of generatedPieces">
                  <div class="piece-label fw-bold">{{piece.label}}</div>
                  <div class="piece-dims">{{piece.width}} in x {{piece.length}} in</div>
                  <div class="piece-qty">Qty {{piece.qty}}</div>
                </div>
              </div>
            </div>

            <!-- Remaining Material -->
            <div class="remaining-material-section" *ngIf="totalInternalQty > 0">
              <h5 class="mb-2">Remaining Material</h5>
              <p>Your configuration leaves material outside of the requested pieces. Would you like to include it with your order?</p>
              <label class="d-flex align-items-center cursor-pointer ms-2 m-4">
                <div class="custom-radio d-inline-flex">
                  <input type="radio" class="custom-control-input" [(ngModel)]="includeRemainingMaterial" [value]="true" name="remainingMaterial">
                </div>
                <span [ngClass]="{'selected-label': includeRemainingMaterial === true}" class="text-uppercase">Include Remaining Material</span>
              </label>
              <label class="d-flex align-items-center cursor-pointer ms-2">
                <div class="custom-radio d-inline-flex">
                  <input type="radio" class="custom-control-input" [(ngModel)]="includeRemainingMaterial" [value]="false" name="remainingMaterial">
                </div>
                <span [ngClass]="{'selected-label': includeRemainingMaterial === false}"   class="text-uppercase">Do Not Include Remaining Material</span>
              </label>
            </div>

            </ng-container>
            <!-- ── END CUTTING / OTHER SERVICES UI ───────────────── -->

          </div>
        </div>

 } @else {
        <div class="saved-cut-view premium-summary">
          <div class="measurements-list mb-4">
            <h5 class="section-title-premium mb-4">{{getInternalQtyLabel(selectedService) | titlecase}} Measurements
            </h5>
            <div class="measurement-table">
              <div class="table-header row g-0 pb-2">
                <div class="col-4 text-uppercase small">{{getInternalQtyLabel(selectedService)}} QTY
                </div>
                <div class="col-4 text-uppercase small">WIDTH</div>
                <div class="col-4 text-uppercase small">LENGTH</div>
              </div>
              <div class="table-row row g-0" *ngFor="let m of draftConfig?.measurements">
                <div class="col-4">{{m.qty}}</div>
                <div class="col-4">{{m.width}} in</div>
                <div class="col-4">{{m.length}} in</div>
              </div>
            </div>
          </div>

          <div class="summary-footer pt-4">
            <div class="d-flex justify-content-between mb-4">
              <h4 class="m-0 fw-bold total-label">Total</h4>
              <div class="text-end">
                <h4 class="m-0 fw-bold total-price">{{draftConfig?.totalAmount | currency: 'USD'}}</h4>
                <span class="total-subtext">
                  {{totalInternalQty}} {{getInternalQtyLabel(selectedService)}}{{totalInternalQty > 1 ? 's' : ''}}
                  <span *ngIf="totalInternalQty > draftConfig?.includedQtyInMinimumFee">
                    ({{draftConfig?.includedQtyInMinimumFee}} + {{totalInternalQty -
                    draftConfig?.includedQtyInMinimumFee}} additional)
                  </span>
                </span>
              </div>
            </div>

            <div class="action-row d-flex align-items-center justify-content-end mt-3">
              <!-- <div class="d-flex gap-2"> -->
                <button *ngIf="showSavedState" class="is-saving px-2 py-1"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> Saved</button>
                <button class="saved-action-btn" (click)="onEditCut()">
                  <img src="/edit-iocn.svg" alt="edit" > Edit
                </button>
                <button class="saved-action-btn" (click)="onRemoveCut()">
                  <img src="/del-icon.svg" alt="delete" > Remove
                </button>
              <!-- </div> -->
              <!-- <button class="btn btn-info-custom px-5 py-2 fw-bold" style="width: auto; border-radius: 8px;"
                (click)="onContinueFromConfigure()">
                CONTINUE
              </button> -->
            </div>
          </div>
        </div>
        }

      </div>
        @if (isReviewStep) {
        <!-- Review footer -->
        <div class="configure-bottom-footer border-top review">
          <div class="d-flex">
            <button class="btn-back-to-items flex-grow-1" [disabled]="isSavingService" (click)="wizardBack()">
              <img src="/images/svg/backward.svg" alt=""> BACK TO <span class="back-configure-word">CONFIGURE </span>{{wizardServices[wizardServices.length - 1]?.name | uppercase}}
            </button>
            <button class="btn-save-to-group flex-grow-1" [class.is-saving]="isSavingService" [disabled]="isSavingService" (click)="saveAllWizard()">
              <span *ngIf="isSavingService" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ isSavingService ? 'SAVING...' : (cameFromVariantEdit ? 'SAVE SERVICE' : 'SAVE & ADD TO ' + getActiveGroupLabel()) }}
              <img *ngIf="!isSavingService" src="/images/svg/forward.svg" alt="">
            </button>
          </div>
        </div>
        } @else if (draftConfig && !draftConfig?.isSaved) {
        <!-- Bottom price + action footer -->
        <div class="configure-bottom-footer border-top">
          <div class="configure-final-info mb-1">
            <ng-container *ngIf="selectedService?.name === 'Bending'">
              Starting {{selectedService?.minimumServiceFee | currency: 'USD'}} (includes {{selectedService?.includedQtyInMinimumFee}} bends) &bull;
              {{selectedService?.eachAdditionalPrice | currency: 'USD'}} per additional bend
            </ng-container>
            <ng-container *ngIf="selectedService?.name !== 'Bending'">
              Starting {{selectedService?.minimumServiceFee | currency: 'USD'}} (includes {{selectedService?.includedQtyInMinimumFee}} {{getInternalQtyLabel(selectedService) || 'cut'}}s) &bull;
              {{selectedService?.eachAdditionalPrice | currency: 'USD'}} per additional {{getInternalQtyLabel(selectedService) || 'cut'}}
            </ng-container>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="fw-bold sub-total" *ngIf="selectedService?.name === 'Bending'">Subtotal ({{totalBendsFor(draftConfig)}} bend{{totalBendsFor(draftConfig) !== 1 ? 's' : ''}})</span>
            <span class="fw-bold sub-total" *ngIf="selectedService?.name !== 'Bending'">Subtotal ({{totalInternalQty}} {{getInternalQtyLabel(selectedService) || 'cut'}}{{totalInternalQty !== 1 ? 's' : ''}})</span>
            <span class="fw-bold value">{{calcServiceTotal(draftConfig) | currency: 'USD'}}</span>
          </div>
          <div class="d-flex">
            <!-- Back: to the Editing Services drawer, to items (step 0), or to previous service step -->
            <button *ngIf="cameFromEditServices" class="btn-back-to-items flex-grow-1" [disabled]="isSavingService" (click)="backToEditServices()">
              <img src="/images/svg/backward.svg" alt=""> BACK TO SERVICES
            </button>
            <button *ngIf="!cameFromEditServices" class="btn-back-to-items flex-grow-1" [disabled]="isSavingService" (click)="wizardBack()">
              <ng-container *ngIf="wizardStep === 0"><img src="/images/svg/backward.svg" alt=""> BACK TO ITEMS</ng-container>
              <ng-container *ngIf="wizardStep > 0"><img src="/images/svg/backward.svg" alt=""> BACK TO {{wizardServices[wizardStep - 1]?.name | uppercase}}</ng-container>
            </button>

            <!-- Forward: configure next service, review, or save (single) -->
            <button *ngIf="usesWizardReviewFlow && !isLastWizardService" class="btn-save-to-group flex-grow-1" [disabled]="(selectedService?.name !== 'Bending' && !isCutMeasurementsValid) || (selectedService?.name === 'Bending' && !isBendConfigValid)" (click)="wizardNext()">
              CONFIGURE {{nextWizardServiceName | uppercase}} <img src="/images/svg/forward.svg" alt="">
            </button>
            <button *ngIf="usesWizardReviewFlow && isLastWizardService" class="btn-save-to-group flex-grow-1" [disabled]="(selectedService?.name !== 'Bending' && !isCutMeasurementsValid) || (selectedService?.name === 'Bending' && !isBendConfigValid) || bendingPieceUnselected" (click)="wizardNext()">
              REVIEW SERVICES <img src="/images/svg/forward.svg" alt="">
            </button>
            <button *ngIf="!usesWizardReviewFlow" class="btn-save-to-group flex-grow-1" [class.is-saving]="isSavingService" [disabled]="isSavingService || (selectedService?.name !== 'Bending' && !isCutMeasurementsValid) || (selectedService?.name === 'Bending' && !isBendConfigValid) || (cameFromEditServices && !isDraftDirty())" (click)="cameFromEditServices ? saveEditServiceConfig() : saveService()">
              <span *ngIf="isSavingService" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ isSavingService ? 'SAVING...' : (cameFromEditServices ? 'SAVE ' + (selectedService?.name | uppercase) : (cameFromVariantEdit ? 'SAVE SERVICE' : 'SAVE & ADD TO ' + getActiveGroupLabel())) }}
              <img *ngIf="!isSavingService" src="/images/svg/forward.svg" alt="">
            </button>
          </div>
        </div>
      }
      </div>
      }
    </div>
  </div>
  }@else if(editingVariantServices){
  <!-- ── Editing Services drawer for a cart variant ── -->
  <div class="custom-drawer multipleVarients editingServices" [class.open]="multipleVarientsPopupOpen" [class.gen-centered]="generatorMode" tabindex="-1">
    <div class="drawer-header d-flex justify-content-end align-items-center px-3">
      <a href="javascript:void(0)" (click)="closeMultipleVarientsPopup()">
        <img src="/images/svg/cross.svg" alt="Close" />
      </a>
    </div>
    <div>
      <a href="javascript:void(0)" class="back-to-variants d-flex align-items-center gap-3" (click)="closeVariantEditServices()">
        <img src="/images/svg/back.svg" alt=""> {{ generatorMode ? 'Cancel' : quoteMode ? 'Back to Quote' : 'Back to Variants in cart' }}
      </a>
    </div>
    <div class="editing-services-head text-center mt-2 mb-4">
      <h4 class="title editing-title m-0">
        Editing Services
        <span class="editing-attrs">
          @for (attr of editingVariant?.product?.attributeSelector | keyvalue; track attr.key) {
            @for (val of $any(attr.value); track val.attributeValue) {
              @if (isAttributeActive(val, editingVariant.product)) {
                <span class="attr-text">&bull; {{val.attributeValue}}</span>
              }
            }
          }
        </span>
      </h4>
      <p class="editing-subtitle m-0">Add or update services for this variant</p>
    </div>

    <div class="drawer-body py-2 mb-3 px-3">
      <h6 class="apply-services-label mb-3">Which services would you like to apply?</h6>

      <div class="configured-services-section">
        <ng-container *ngFor="let service of getFilteredServicesForConfig(selectedProductForNewConfig); trackBy: trackByServiceName">

          <!-- Configured: summary card with Edit / Remove -->
          <div class="configured-service-card p-3 border mb-3 bg-white"
            *ngIf="getVariantOptionForService(editingVariant, service) as option">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-3">
                <img [src]="service.img" alt="" class="service-config-icon">
                <div>
                  <span class="service-card-title fw-semibold d-block">
                    {{service.name}}<span *ngIf="service.name !== 'Punching'"> &bull; {{getServiceConfigSummary(option)}}</span>
                  </span>
                  <span class="d-block text-muted small">{{getServiceConfigSubLabel(editingVariant, option)}}</span>
                </div>
                <span class="added-badge" *ngIf="option.__justAdded">
                          <img src="/images/svg/blue-tick.svg" alt=""> Added
                        </span>
              </div>
              <div class="d-flex align-items-center gap-3">
                <a href="javascript:void(0)" class="service-action-link edit" *ngIf="service.name !== 'Punching'" (click)="onViewVariantServiceConfig(editingVariant, option)">
                  <img src="/images/svg/edit.svg" alt=""> Edit
                </a>
                <a href="javascript:void(0)" class="service-action-link remove" (click)="removeVariantServiceOption(editingVariant, option)">
                  <img src="/images/svg/delete.svg" alt=""> Remove
                </a>
              </div>
            </div>
          </div>

          <!-- Not configured: tick to select (card or checkbox); configuring happens from "Update Services" -->
          <div class="group-service-row addNewProduct"
            *ngIf="!getVariantOptionForService(editingVariant, service)"
            (click)="toggleEditVariantService(service)">
            <label class="custom-checkbox d-flex" (click)="$event.stopPropagation()">
              <div class="outer-checkBox">
                <input type="checkbox" class="group-service-checkbox"
                  [checked]="isEditVariantServiceSelected(service)"
                  (change)="toggleEditVariantService(service)">
                <div class="checkmark">
                  <img src="/images/svg/check-tick.svg" alt="checked">
                </div>
              </div>
            </label>
            <div class="variant-card flex-grow-1 m-0"
              [class.variant-card-selected]="isEditVariantServiceSelected(service)">
              <div class="d-flex align-items-center flex-grow-1">
                <div class="service-icon-box">
                  <img [src]="service.img" alt="">
                </div>
                <div class="service-info-main">
                  <h5 class="m-0">{{service.name}}</h5>
                  <span class="attr-text">{{service.msg}}</span>
                </div>
              </div>
              <div class="d-flex align-items-center m-version-price">
                <div class="price-section">
                  <div class="price-main">Starting at {{service.minimumServiceFee | currency: 'USD' : 'symbol' : '1.2-2'}} <span>(min {{service.includedQtyInMinimumFee}})</span></div>
                  <div class="price-sub">+{{service.eachAdditionalPrice | currency: 'USD'}} per extra</div>
                </div>
              </div>
            </div>
          </div>

        </ng-container>
      </div>

      <!-- Bend / cut relationship hint -->
      <p class="bend-context-note mb-3" *ngIf="editVariantBendNote() as note">
        <img src="/images/svg/info.svg" alt="" class="bend-context-icon">
        <span>{{ note }}</span>
      </p>

      <!-- Upload File Section -->
      <div class="upload-section mb-4 pt-2">
        <label class="form-label mb-1">Upload File (Optional)</label>
        <p class="text-muted mb-3">Add a diagram or instructions to insure accurate result.</p>

        <div *ngIf="!editingVariant?.uploadedFile" class="upload-dropzone border-dashed rounded"
          (drop)="onFileDropped($event)" (dragover)="$event.preventDefault()">
          <div class="d-flex align-items-center gap-3">
            <img src="./pdf-icon.svg" alt="" class="upload-icon">
            <div class="d-flex flex-column align-items-start">
              <p class="mb-0 upload-text">
                Drop your file here, or
                <label class="browse-link mb-0">
                  Browse Files
                  <input type="file" class="d-none" (change)="onFileSelected($event, editingVariant)">
                </label>
              </p>
              <p class="text-muted mb-0 supported-text">Supported: PDF, JPG, PNG (max 5MB)</p>
            </div>
          </div>
        </div>

        <div *ngIf="editingVariant?.uploadedFile"
          class="file-upload-preview d-flex align-items-center justify-content-between p-3 border rounded">
          <div class="d-flex align-items-center gap-2">
            <div class="file-icon-box">
              <img src="/images/svg/pdf-1.svg" alt="pdf">
            </div>
            <div class="d-flex flex-column">
              <span class="file-name">{{editingVariant.uploadedFile.name}}</span>
              <span class="text-muted upload-status">Upload Successful</span>
            </div>
          </div>
          <a href="javascript:void(0)" class="inline-config-link remove" (click)="onFileRemove(editingVariant)">
            <img src="/images/svg/delete.svg" alt="remove" class="inline-config-icon"> Remove
          </a>
        </div>
      </div>
    </div>

    <div class="editing-services-footer d-flex gap-3 px-3 pb-3">
      <button class="btn-back-to-items flex-grow-1" (click)="closeVariantEditServices()">
        <img src="/images/svg/backward.svg" alt=""> {{ (quoteMode || generatorMode) ? 'CANCEL' : 'BACK TO VARIANTS IN CART' }}
      </button>
      <button class="btn-save-to-group flex-grow-1" [disabled]="!hasServiceEdits" (click)="onUpdateServicesClick()">
        {{ generatorMode ? 'SAVE SCHEMA' : quoteMode ? 'SAVE SERVICES' : 'UPDATE SERVICES' }} <img src="/images/svg/forward.svg" alt="">
      </button>
    </div>
  </div>
  }@else{
  <div class="custom-drawer multipleVarients" [class.open]="multipleVarientsPopupOpen" tabindex="-1">
    <!-- <div class="drawer-header d-flex justify-content-between align-items-center px-3">
      <div class="filterHeader w-100 position-relative">
        <div class="topBar mt-5"></div>
        <div class="close-btn-main">
          <a type="button" class="btn-close" (click)="closeMultipleVarientsPopup()"></a>
        </div>
      </div>
    </div> -->
      <div class="drawer-header d-flex justify-content-end align-items-center px-3">
          <a href="javascript:void(0)" (click)="closeMultipleVarientsPopup()">
           <img src="/images/svg/cross.svg" alt="Close" />
          </a>
    </div>
    <div style="margin-bottom: 32px;">
      <h4 class="title mt-2 mb-1"><img class="me-2 mb-1" src="/cartMain.svg" alt="">Variants Already in Cart</h4>
      <!-- <div class="d-flex align-items-center gap-2">
        <span class="inCart m-0">Already in cart</span>
      </div> -->
    </div>

    @if (!addNewConfig) {
    <div class="drawer-body py-2 mb-3">
      <div class="variant-card mb-3 position-relative" *ngFor="let variant of visibleVariants">
        <!-- <a type="button" class="btn-remove-card position-absolute" (click)="deleteVariant(variant)">
          <img src="/images/svg/close.svg" alt="remove">
        </a> -->
        <div class="d-flex align-items-start">
          <div class="variant-img-wrapper me-3">
            <img class="variant-img" [src]="variant.product?.imageUrl || './placeholder.svg'" alt="variant">
          </div>
          <div class="flex-grow-1">
            <div class="d-flex flex-wrap justify-content-between align-items-center variant-attributes mb-1 pb-1">
              <div class="d-flex align-items-center gap-2">
                @for (attr of variant.product.attributeSelector | keyvalue; track attr.key; let isLast = $last) {
                <div class="d-flex align-items-center">
                  @for (val of $any(attr.value); track val.attributeValue) {
                  @if (isAttributeActive(val, variant.product)) {
                  <span class="attr-text">{{val.attributeValue}}</span>
                  }
                  }
                  <!-- <span class="dot-separator mx-1">●</span> -->
                </div>
                }
                <span class="attr-qty-text">({{variant.qty}})</span>
              </div>
              <div class="d-flex align-items-center variant-service" *ngIf="variant.options?.length > 0">
                <span>Services</span>
                <div *ngFor="let service of variant.options"
                     class="variant-service-icon"
                     [pTooltip]="getServiceName(service.productOptionType)"
                     tooltipPosition="top">
                  <img [src]="getServiceImgByType(service.serviceType)" [alt]="getServiceName(service.productOptionType)">
                </div>
              </div>
            </div>

            <div class="qty-control d-flex align-items-center my-2">
              <button class="qty-btn" (click)="handleVariantMinus(variant)">
                <img src="/images/svg/mins.svg" alt="minus" class="icon-40">
              </button>
              <div class="qty-value px-3 flex-grow-1 text-center">{{ variant.qty }}</div>
              <button class="qty-btn" (click)="handleVariantPlus(variant)">
                <img src="/images/svg/pls.svg" alt="plus" class="icon-40">
              </button>
            </div>

            <div class="subtotal-row d-flex justify-content-between mt-4">
              <span class="subtotal-label">Subtotal</span>
              <span class="subtotal-amount">${{ (variant.price * variant.qty) | number: '1.2-2' }} ({{variant.price | currency:'USD'}}/each)</span>
            </div>
          </div>
        </div>
        <!-- Expanded edit details -->
        <div class="edit-details-expanded" *ngIf="variant.showEditDetails">

          <!-- Attribute sections -->
          <div class="edit-detail-section" *ngFor="let attr of selectedProductForNewConfig?.attributeSelector | keyvalue">
            <div class="edit-detail-row" (click)="toggleSection(variant, $any(attr.key))">
              <div class="d-flex">
                <span class="edit-detail-label">{{$any(attr.key).replace('_', ' ')}}</span> 
                <span class="edit-detail-value ms-4">{{getActiveValue(variant, $any(attr.key))}}</span>
              </div>
              <div class="edit-detail-value">
                <!-- <span class="color-swatch"
                  *ngIf="$any(attr.key).toLowerCase().includes('color')"
                  [style.background-color]="getActiveValue(variant, $any(attr.key))"></span> -->
                <img src="/images/svg/dropdown.svg" alt="" class="detail-chevron"
                  [class.expanded]="isSectionExpanded(variant, $any(attr.key))">
              </div>
            </div>
            <div class="edit-detail-options" *ngIf="isSectionExpanded(variant, $any(attr.key))">
              <div class="option-chips">
                @for (val of $any(attr.value); track val.attributeValue) {
                <div class="option-chip"
                  [class.active]="isAttributeActive(val, variant.product) && !checkVariantPreviousSelected(variant, val.attributeValue, $any(attr.key))"
                  [class.previous-option]="isAttributeActive(val, variant.product) && checkVariantPreviousSelected(variant, val.attributeValue, $any(attr.key))"
                  [class.disabled]="!val.isSame && !isAttributeActive(val, variant.product) && !isOptionQuotesOnly(val)"
                  [class.out-of-stock]="!isAttributeActive(val, variant.product) && (isOptionQuotesOnly(val) || (val.isSame && isOptionOutOfStockOrQuotes(val)))"
                  [pTooltip]="getOptionTooltip(val, variant.product)"
                  [tooltipPosition]="'top'"
                  [tooltipStyleClass]="'option-tooltip'"
                  [appendTo]="'body'"
                  (click)="onVariantOptionClick(variant, val, $any(attr.key))">
                  {{val.attributeValue}}
                </div>
                }
              </div>
              <div *ngIf="checkVariantPreviousSelected(variant, findVariantSelectedValue(variant, $any(attr.key)), $any(attr.key))"
                class="variant-inline-note mt-1">
                <img src="orange-warning.svg" alt="" class="variant-inline-note-icon">
                <span>{{ getVariantAutoSelectedMessage(variant, $any(attr.key)) }}</span>
              </div>
            </div>
          </div>

          <!-- Quantity section -->
          <div class="edit-detail-section">
            <div class="edit-detail-row" (click)="toggleSection(variant, 'quantity')">
              <div class="d-flex">
                <span class="edit-detail-label">Quantity</span>
                  <span class="edit-detail-value ms-4">{{variant.qty}}</span>
              </div>
              <div class="edit-detail-value">
              
                <img src="/images/svg/dropdown.svg" alt="" class="detail-chevron"
                  [class.expanded]="isSectionExpanded(variant, 'quantity')">
              </div>
            </div>
            <div class="edit-detail-options" *ngIf="isSectionExpanded(variant, 'quantity')">
              <div class="qty-control d-flex align-items-center">
                <button class="qty-btn" (click)="handleVariantMinus(variant); $event.stopPropagation()">
                  <img src="/images/svg/mins.svg" alt="minus" class="icon-40">
                </button>
                <div class="qty-value flex-grow-1 text-center font-bold">{{ variant.qty }}</div>
                <button class="qty-btn" (click)="handleVariantPlus(variant); $event.stopPropagation()">
                  <img src="/images/svg/pls.svg" alt="plus" class="icon-40">
                </button>
              </div>
            </div>
          </div>

          <!-- Service section -->
          <div class="edit-detail-section">
            <div class="edit-detail-row" (click)="toggleVariantServiceSection(variant)">
              <div class="d-flex align-items-center">
              <span class="edit-detail-label">Service</span>
              <span class="edit-detail-value ms-4 d-flex align-items-center gap-2" *ngIf="variant.options?.length > 0">
                <span>{{ getVariantServiceNames(variant) }}</span>
                <span class="d-inline-flex align-items-center gap-1 ms-2">
                  <img *ngFor="let option of variant.options" [src]="getServiceImgByType(option.serviceType)"
                    [alt]="getServiceName(option.productOptionType)" class="service-detail-icon">
                </span>
              </span>
              <span class="edit-detail-value ms-4 text-muted" *ngIf="!(variant.options?.length > 0)">No services</span>
              </div>
              <div class="edit-detail-value">
                <img src="/images/svg/dropdown.svg" alt="" class="detail-chevron"
                  [class.expanded]="isSectionExpanded(variant, 'service')">
              </div>
            </div>
            <div class="edit-detail-options" *ngIf="isSectionExpanded(variant, 'service')">

              <!-- Services: product-detail style (Add Services button / saved summary) -->
              <div class="variant-services-flow pt-3 pb-2">

                <!-- No services yet → Add Services button (opens the Editing Services drawer) -->
                <a *ngIf="!(variant.options?.length > 0)" class="add-services-btn"
                  (click)="openVariantEditServices(variant)">
                  <span class="plus-icon me-1">+</span> ADD SERVICES
                </a>

                <!-- Services configured → summary card with edit / remove -->
                <ng-container *ngIf="variant.options?.length > 0">
                  <div class="saved-service-card" [class.just-saved]="variant.__justSavedServices">
                    <img class="me-2" src="/images/svg/b-tick.svg" alt="">
                    <span class="ms-1 saved-service-names">{{ getVariantServiceNames(variant) }}</span>
                    <span class="added-badge ms-2" *ngIf="variant.__justSavedServices">
                      <img src="/images/svg/blue-tick.svg" alt=""> Added
                    </span>
                    <span class="ms-auto d-flex align-items-center gap-2">
                      <a class="saved-service-icon" (click)="openVariantEditServices(variant)">
                        <img src="/images/svg/edit.svg" alt="edit"></a>
                      <!-- <a class="saved-service-icon" (click)="removeVariantServices(variant)">
                        <img src="/images/svg/delete.svg" alt="remove"></a> -->
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

        </div>
        <div class="d-flex justify-content-end mt-3 var-btns">
          <button class="btn-edit-details me-3"
          (click)="toggleEditDetails(variant)">
          <span class="m-auto d-flex align-items-center">
            
            <!-- Edit icon on left -->
            <img
            *ngIf="!variant.showEditDetails"
            src="/images/svg/edit.svg"
            alt=""
            class="me-2"
            >
            
            {{ variant.showEditDetails ? 'Done' : 'Edit Details' }}
            
            <!-- Dropdown icon on right -->
            <img
            *ngIf="variant.showEditDetails"
            src="/images/svg/blue-dropdown.svg"
            alt=""
            class="ms-2"
            style="transform: rotate(180deg);"
            >

        </span>
        </button>
        <a type="button" class="btn-remove-var" (click)="deleteVariant(variant)">
          <img src="/images/svg/delete.svg" alt="remove"> <span class="ms-2">Remove</span>
        </a>
         <!-- <a type="button" class="btn-remove-card position-absolute" (click)="deleteVariant(variant)">
          <img src="/images/svg/close.svg" alt="remove">
        </a> -->
        </div>
      </div>
      <!-- <div class="total-row d-flex justify-content-between mb-4">
        <span class="total-label">Total</span>
        <span class="total-amount">${{ getVariantGrandTotal() | number: '1.2-2' }}</span>
      </div> -->
      <!-- <button class="btn-add-new w-100 " (click)="onAddNewConfiguration()">
        ADD NEW CONFIGURATION
      </button> -->
    </div>

    <div class="drawer-footer d-flex align-items-center justify-content-between">
      <a href="javascript:void(0)" class="cancel-link" (click)="closeMultipleVarientsPopup()">
        Cancel
      </a>
      <button class="btn-done-variant"
        [disabled]="!hasVariantChanges()"
        [class.btn-done-disabled]="!hasVariantChanges()"
        (click)="saveVariantChanges()">
        SAVE CHANGES
      </button>
    </div>
    }@else {
    <div class="h-100">
      <app-add-services-modal [addNewConfig]="addNewConfig" [selectedProduct]="selectedProductForNewConfig"
        [filterServices]="filterServicesForNewConfig" (onBack)="onNewConfigBack($event)">
      </app-add-services-modal>
    </div>
    }
  </div>
  }


  <div class="discard-modal-overlay" *ngIf="showDiscardPopup">
    <div class="discard-modal p-4 rounded bg-white shadow">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="m-0 fw-bold">Discard changes?</h5>
        <button class="border-0 bg-transparent p-0" (click)="cancelDiscard()">
          <img src="/images/svg/close.svg" alt="close" class="icon-14">
        </button>
      </div>
      <p class="text-muted small mb-4">Your changes won't be saved.</p>
      <div class="d-flex gap-3">
        <button class="btn btn-outline-discard w-100 py-2 fw-bold" (click)="cancelDiscard()">KEEP EDITING</button>
        <button class="btn btn-discard w-100 py-2 fw-bold text-white" (click)="confirmDiscard()">DISCARD</button>
      </div>
    </div>
  </div>

  <!-- Service Unavailable Confirmation Popup -->
  <div class="discard-modal-overlay" *ngIf="showServiceUnavailablePopup">
    <div class="service-unavailable-modal p-4 rounded bg-white shadow">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="m-0">Services Need Updating</h5>
        <button class="border-0 bg-transparent p-0" (click)="cancelServiceUnavailable()">
          <img src="/images/svg/close.svg" alt="close" class="icon-14">
        </button>
      </div>
      <p class="serv-info">The services configured for this variant are not available for the selected option. Continuing will remove the following services:</p>
      <div class="service-list mb-4" *ngIf="unavailableServiceOptions?.length; else allServices">
        Affected services that will reset:
        <div class="service-list-item" *ngFor="let opt of unavailableServiceOptions">
          <span>{{ getServiceName(opt.productOptionType) }}</span>
        </div>
      </div>
      <ng-template #allServices>
        <div class="m-service-list">
          <div class="service-list mb-3" *ngIf="serviceUnavailableVariant?.options?.length">
            Affected services:
            <div class="service-list-item" *ngFor="let opt of serviceUnavailableVariant.options">
              <span>{{ getServiceName(opt.productOptionType) }}</span>
            </div>
          </div>
        </div>
      </ng-template>
      <div class="d-flex mt-4 gap-3 justify-content-end f-button">
        <button class="btn btn-outline-cancel fw-bold" (click)="cancelServiceUnavailable()">CANCEL</button>
        <button class="btn btn-discard fw-bold text-white text-uppercase" (click)="confirmServiceUnavailable()">Continue & reconfigure services</button>
      </div>
    </div>
  </div>

  <!-- Service validation — Scenario 1: Additional material / quantity required -->
  <div class="discard-modal-overlay" *ngIf="showServiceQtyPopup">
    <div class="service-validation-modal p-4 rounded bg-white shadow">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <h5 class="m-0">Additional Material Required</h5>
        <button class="border-0 bg-transparent p-0" (click)="serviceValidationEditServices()">
          <img src="/images/svg/close.svg" alt="close" class="icon-14">
        </button>
      </div>
      <p class="serv-info">Based on your selected services, additional material is required to complete this
        configuration.</p>
      <div class="validation-info-box mb-3">
        <div class="info-label">Current quantity: <span>{{ validationCurrentQty }} units</span></div>
        <div class="info-label">Required quantity: <span class="text-required">{{ validationRequiredQty }} units</span></div>
      </div>
      <p class="text-muted small mb-4">Updating your quantity will increase your product quantity and pricing.</p>
      <p class="update-qty">Would you like to update your order quantity?</p>
      <div class="d-flex gap-3">
        <button class="btn btn-outline-discard w-100 text-uppercase"
          (click)="serviceValidationEditServices()">Edit Services</button>
        <button class="btn btn-discard w-100 text-uppercase"
          (click)="serviceValidationUpdateQuantity()">Update Quantity</button>
      </div>
    </div>
  </div>

  <!-- Service validation — Scenario 2: Larger size required (a compatible size exists) -->
  <div class="discard-modal-overlay" *ngIf="showServiceSizePopup">
    <div class="service-validation-modal p-4 rounded bg-white shadow">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <h5 class="m-0">Larger Size Required</h5>
        <button class="border-0 bg-transparent p-0" (click)="serviceValidationEditServices()">
          <img src="/images/svg/close.svg" alt="close" class="icon-14">
        </button>
      </div>
      <p class="serv-info">The selected size can't accommodate the requested service dimensions, but a larger
        compatible size is available.</p>
      <div class="validation-info-box mb-3">
        <div *ngIf="validationCurrentSize" class="info-label">Current size: <span>{{ validationCurrentSize }}</span></div>
        <div class="info-label">Suggested size: <span class="text-required">{{ validationSuggestedSize?.label }}</span></div>
      </div>
      <p class="update-qty">Would you like to update the product size?</p>
      <div class="d-flex gap-3">
        <button class="btn btn-outline-discard w-100 text-uppercase"
          (click)="serviceValidationEditServices()">Edit Services</button>
        <button class="btn btn-discard w-100  text-uppercase"
          (click)="serviceValidationUpdateSize()">Update Size</button>
      </div>
    </div>
  </div>

  <!-- Service validation — Scenario 3: No compatible size exists -->
  <div class="discard-modal-overlay" *ngIf="showServiceNoSizePopup">
    <div class="service-validation-modal p-4 rounded bg-white shadow">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <h5 class="m-0">Configuration Not Available</h5>
        <button class="border-0 bg-transparent p-0" (click)="serviceValidationEditServices()">
          <img src="/images/svg/close.svg" alt="close" class="icon-14">
        </button>
      </div>
      <p class="serv-info">The requested service specifications can't be fulfilled with any available size.
        Please adjust your service configuration.</p>
      <div class="d-flex justify-content-end">
        <button class="btn btn-discard text-uppercase"
          (click)="serviceValidationEditServices()">Edit Services</button>
      </div>
    </div>
  </div>

  <!-- Reusable cutting/bending confirmation popup. One data-driven modal reused for
       every "cutting changes invalidate bending" scenario (add / remove / edit cutting,
       remove cut piece). Content comes from the serviceConfirm object set in the TS. -->
  <div class="discard-modal-overlay" *ngIf="serviceConfirm">
    <div class="service-validation-modal p-4 rounded bg-white shadow">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="m-0">{{ serviceConfirm.title }}</h5>
        <button class="border-0 bg-transparent p-0" (click)="cancelServiceConfirm()">
          <img src="/images/svg/close.svg" alt="close" class="icon-14">
        </button>
      </div>
      <p class="serv-info">{{ serviceConfirm.message }}</p>
      <div class="service-list mb-4" *ngIf="serviceConfirm.affected?.length">
        Affected Services:
        <div class="service-list-item" *ngFor="let name of serviceConfirm.affected">
          <span>{{ name }}</span>
        </div>
      </div>
      <div class="d-flex mt-4 gap-3 ser-button">
        <button class="btn btn-outline-cancel fw-bold" (click)="cancelServiceConfirm()">{{ serviceConfirm.cancelLabel }}</button>
        <button class="btn btn-discard fw-bold text-white text-uppercase" (click)="confirmServiceConfirm()">{{ serviceConfirm.confirmLabel }}</button>
      </div>
    </div>
  </div>